
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequire49d7"];
var parcelRegister = parcelRequire.register;
parcelRegister("2Q8el", function(module, exports) {

$parcel$export(module.exports, "RenderEngagementMessages", () => $5c808498c9d51887$export$afddd1e0dec3ab7e);

var $5uXOq = parcelRequire("5uXOq");

var $7nsd3 = parcelRequire("7nsd3");

var $lrPLa = parcelRequire("lrPLa");

var $2YZCu = parcelRequire("2YZCu");

var $jsLXn = parcelRequire("jsLXn");

var $5tsrJ = parcelRequire("5tsrJ");

var $9F6Ii = parcelRequire("9F6Ii");

var $14XJw = parcelRequire("14XJw");
const $5c808498c9d51887$var$throwError = (message)=>{
    const error = new Error(message);
    (0, $2YZCu.default).safeErrorWithoutCustomerData('engagement-messages.entry', message, error);
    throw error;
};
const $5c808498c9d51887$var$getContainer = ()=>{
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    let container = document.getElementById('engagement-messages');
    if (container == null) {
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        container = document.createElement('div');
        container.id = 'engagement-messages';
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        if (document.body) // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        document.body.appendChild(container);
        else $5c808498c9d51887$var$throwError('document.body was not found whilst trying to create the engagement-messages container');
    }
    return container;
};
const $5c808498c9d51887$var$GetDom = ()=>{
    const { data: orgId } = (0, $14XJw.useOrgId)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9F6Ii.StrictMode), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jsLXn.JiraContextContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5tsrJ.default), {
        orgId: orgId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lrPLa.EngagementMessages), null))));
};
const $5c808498c9d51887$export$afddd1e0dec3ab7e = ()=>(0, $7nsd3.render)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($5c808498c9d51887$var$GetDom, null), $5c808498c9d51887$var$getContainer());
$5c808498c9d51887$export$afddd1e0dec3ab7e();

});
parcelRegister("lrPLa", function(module, exports) {

$parcel$export(module.exports, "EngagementMessages", () => $3bb9e087476f8e5e$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $dOR3T = parcelRequire("dOR3T");

var $carTE = parcelRequire("carTE");

var $gdk09 = parcelRequire("gdk09");
class $3bb9e087476f8e5e$export$2e2bcd8739ae039 extends (0, $5uXOq.Component) {
    render() {
        return /*#__PURE__*/ (0, $2OMIu.jsxs)("div", {
            children: [
                /*#__PURE__*/ (0, $2OMIu.jsx)((0, $gdk09.default), {}),
                /*#__PURE__*/ (0, $2OMIu.jsx)((0, $carTE.default), {}),
                /*#__PURE__*/ (0, $2OMIu.jsx)((0, $dOR3T.default), {})
            ]
        });
    }
}

});
parcelRegister("dOR3T", function(module, exports) {

$parcel$export(module.exports, "default", () => $c05eac4daeabe78e$export$2e2bcd8739ae039);
/* eslint-disable @atlassian/tangerine/import/no-restricted-paths, @atlassian/tangerine/import/no-parent-imports */ 
var $GH25Y = parcelRequire("GH25Y");

var $jKwFV = parcelRequire("jKwFV");

var $cK5Hh = parcelRequire("cK5Hh");
const $c05eac4daeabe78e$export$42b694a35bb75eda = (0, $GH25Y.default)((0, $cK5Hh.default));
var $c05eac4daeabe78e$export$2e2bcd8739ae039 = (0, $jKwFV.default)($c05eac4daeabe78e$export$42b694a35bb75eda, 'contextualSurvey');

});
parcelRegister("cK5Hh", function(module, exports) {

$parcel$export(module.exports, "default", () => $354d891155655b2d$export$2e2bcd8739ae039);
/* eslint-disable @atlassian/tangerine/import/no-restricted-paths, @atlassian/tangerine/import/no-parent-imports */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $43FTR = parcelRequire("43FTR");

var $jrCRr = parcelRequire("jrCRr");

var $54GDw = parcelRequire("54GDw");

var $XFQDz = parcelRequire("XFQDz");
function $354d891155655b2d$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $43FTR.default), {
        shouldShow: true,
        children: ()=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $XFQDz.default), {
                markAsSeenAndFatigued: (0, $jrCRr.markAsSeenAndFatigued),
                sendUserResponse: (0, $jrCRr.sendUserResponse),
                getFlag: (0, $54GDw.getFlag),
                setFlag: (0, $54GDw.setFlag),
                ...props
            })
    });
}

});
parcelRegister("43FTR", function(module, exports) {

$parcel$export(module.exports, "default", () => $84a12f2dd2a65c23$export$2e2bcd8739ae039);
/* SurveyMarshal.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $ahdj0 = parcelRequire("ahdj0");

var $2pYBE = parcelRequire("2pYBE");

var $9Q10z = parcelRequire("9Q10z");
const $84a12f2dd2a65c23$var$animationDuration = 300;
const $84a12f2dd2a65c23$var$offscreen = {
    translateX: `${(0, $9Q10z.surveyInnerWidth) + (0, $9Q10z.surveyOffset)}px`,
    opacity: '0'
};
const $84a12f2dd2a65c23$var$getAnimationProps = (state)=>{
    switch(state){
        case 'entered':
            return {
                translateX: '0',
                opacity: '1'
            };
        case 'entering':
        case 'unmounted':
        case 'exited':
        case 'exiting':
            return $84a12f2dd2a65c23$var$offscreen;
    }
};
const $84a12f2dd2a65c23$var$transitionBaseStyles = null;
function $84a12f2dd2a65c23$export$2e2bcd8739ae039(props) {
    const { children: children, shouldShow: shouldShow } = props;
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ahdj0.default), {
        in: shouldShow,
        timeout: $84a12f2dd2a65c23$var$animationDuration,
        unmountOnExit: true,
        children: (state)=>{
            const { translateX: translateX, opacity: opacity } = $84a12f2dd2a65c23$var$getAnimationProps(state);
            return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
                style: {
                    opacity: opacity,
                    transition: `all ${$84a12f2dd2a65c23$var$animationDuration}ms ease-in-out`,
                    zIndex: (0, $2pYBE.layers).flag(),
                    transform: `translateX(${translateX})`
                },
                className: (0, $bwpsq.default)([
                    "_kqsw1n9t _1xi2ckbl _94n5ckbl _k8m01rjc"
                ]),
                children: children()
            });
        }
    });
}

});
parcelRegister("9Q10z", function(module, exports) {

$parcel$export(module.exports, "surveyInnerWidth", () => $65f1f627cf51b52c$export$cac609a3cdfd0268);
$parcel$export(module.exports, "surveyOffset", () => $65f1f627cf51b52c$export$d3b22831e495441e);

var $2pYBE = parcelRequire("2pYBE");
const $65f1f627cf51b52c$export$cac609a3cdfd0268 = (0, $2pYBE.gridSize)() * 55; // 440
const $65f1f627cf51b52c$export$d3b22831e495441e = (0, $2pYBE.gridSize)() * 6; // 48

});


parcelRegister("54GDw", function(module, exports) {

$parcel$export(module.exports, "getFlag", () => $77cbec214edd11bd$export$a19b74191e00c5e);
$parcel$export(module.exports, "setFlag", () => $77cbec214edd11bd$export$5e165df1e30a1331);

var $M4Zg0 = parcelRequire("M4Zg0");

var $74ePQ = parcelRequire("74ePQ");
const $77cbec214edd11bd$var$hisiGetFlagTemplate = (0, (/*@__PURE__*/$parcel$interopDefault($M4Zg0))).parse('/engage-targeting/api/v2/user/{cloudId}/hisi/flag{?userKey,flagKey}');
const $77cbec214edd11bd$export$9388e2e6cf5978f0 = '/engage-targeting/api/v2/user/{cloudId}/hisi/flag';
async function $77cbec214edd11bd$export$a19b74191e00c5e(stargateUrl, cloudId, flagKey, userKey) {
    return (0, $74ePQ.stargateFetch)(`${stargateUrl}${$77cbec214edd11bd$var$hisiGetFlagTemplate.expand({
        cloudId: cloudId,
        userKey: userKey,
        flagKey: flagKey
    })}`, {
        method: 'GET'
    }).then((0, $74ePQ.errorIfNotOk)).then((r)=>r.json());
}
async function $77cbec214edd11bd$export$5e165df1e30a1331(stargateUrl, cloudId, flagKey, userKey) {
    return (0, $74ePQ.stargateFetch)(`${stargateUrl}${$77cbec214edd11bd$export$9388e2e6cf5978f0}`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({
            userKey: userKey,
            flagKey: flagKey
        })
    }).then((0, $74ePQ.errorIfNotOk)).then((r)=>r).then(()=>Promise.resolve());
}

});

parcelRegister("XFQDz", function(module, exports) {

$parcel$export(module.exports, "default", () => $da2bd44b96568e38$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $8IQhH = parcelRequire("8IQhH");
const $da2bd44b96568e38$var$flagKey = 'atlassian_research_group_mailinglist_actioned';
class $da2bd44b96568e38$export$2e2bcd8739ae039 extends (0, $5uXOq.PureComponent) {
    firePrimaryClickEvent() {
        this.props.fireClickEvent('primary');
    }
    render() {
        return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $8IQhH.default), {
            onDismiss: this.onDismiss,
            getUserHasAnsweredMailingList: this.getUserHasAnsweredMailingList,
            onMailingListAnswer: this.onMailingListAnswer,
            onSubmit: this.onSubmit,
            ...this.props
        });
    }
    constructor(...args){
        super(...args), this.onDismiss = (onDismissArgs)=>{
            const { cloudId: cloudId, messageId: messageId, fireClickEvent: fireClickEvent, stargateUrl: stargateUrl, markAsSeenAndFatigued: markAsSeenAndFatigued, orgId: orgId, workspaceId: workspaceId } = this.props;
            if (onDismissArgs.trigger === (0, $8IQhH.DismissTrigger).Manual) markAsSeenAndFatigued({
                stargateUrl: stargateUrl,
                cloudId: cloudId,
                messageId: messageId,
                orgId: orgId,
                workspaceId: workspaceId
            });
            fireClickEvent('dismiss');
        }, this.getUserHasAnsweredMailingList = async ()=>{
            const { stargateUrl: stargateUrl, aaid: aaid, cloudId: cloudId, getFlag: getFlag } = this.props;
            try {
                await getFlag(stargateUrl, cloudId, $da2bd44b96568e38$var$flagKey, aaid);
                return Promise.resolve(false);
            } catch  {
                return Promise.resolve(true);
            }
        }, this.onSubmit = async (formValues)=>{
            const { cloudId: cloudId, messageId: messageId, question: question, statement: statement, stargateUrl: stargateUrl, markAsSeenAndFatigued: markAsSeenAndFatigued, sendUserResponse: sendUserResponse, orgId: orgId, workspaceId: workspaceId } = this.props;
            const { canContact: canContact, feedbackScore: feedbackScore, writtenFeedback: writtenFeedback } = formValues;
            const payload = {
                responseType: 'ACCEPTANCE_SURVEY',
                properties: {
                    surveyTimestamp: Date.now(),
                    contextualQuestion: question,
                    contextualStatement: statement,
                    quantitativeResponse: feedbackScore,
                    qualitativeResponse: writtenFeedback,
                    contactable: canContact
                }
            };
            markAsSeenAndFatigued({
                stargateUrl: stargateUrl,
                cloudId: cloudId,
                messageId: messageId,
                orgId: orgId,
                workspaceId: workspaceId
            });
            this.firePrimaryClickEvent();
            // Resolving the promise to ensure that spinner of Submit button does not spin forever in case of errors
            return sendUserResponse(cloudId, stargateUrl, messageId, payload).catch(()=>Promise.resolve());
        }, this.onMailingListAnswer = async (answer)=>{
            const { aaid: aaid, cloudId: cloudId, stargateUrl: stargateUrl, messageId: messageId, sendUserResponse: sendUserResponse, setFlag: setFlag } = this.props;
            const payload = {
                responseType: 'MAILING_LIST_RESPONSE',
                properties: {}
            };
            setFlag(stargateUrl, cloudId, $da2bd44b96568e38$var$flagKey, aaid);
            if (!answer) return;
            return sendUserResponse(cloudId, stargateUrl, messageId, payload);
        };
    }
}

});
parcelRegister("8IQhH", function(module, exports) {

$parcel$export(module.exports, "DismissTrigger", () => $23ee5f706a4214fd$export$151efc60ac534d42);
$parcel$export(module.exports, "default", () => $23ee5f706a4214fd$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $lrvs7 = parcelRequire("lrvs7");

var $1OtTj = parcelRequire("1OtTj");

var $etgFa = parcelRequire("etgFa");

var $fZZA0 = parcelRequire("fZZA0");

var $5lQoa = parcelRequire("5lQoa");

var $9sj5Y = parcelRequire("9sj5Y");
var $23ee5f706a4214fd$export$151efc60ac534d42 = /*#__PURE__*/ function(DismissTrigger) {
    DismissTrigger["AutoDismiss"] = "AUTO_DISMISS";
    DismissTrigger["Manual"] = "MANUAL";
    DismissTrigger["Finished"] = "FINISHED";
    DismissTrigger["Unmount"] = "UNMOUNT";
    return DismissTrigger;
}({});
const $23ee5f706a4214fd$export$3e8963a077f85f25 = 8000;
var $23ee5f706a4214fd$export$2e2bcd8739ae039 = ({ question: question, statement: statement, onDismiss: onDismiss, onSubmit: onSubmit, onMailingListAnswer: onMailingListAnswer, getUserHasAnsweredMailingList: getUserHasAnsweredMailingList, textLabel: textLabel = 'Why did you give that rating', textPlaceholder: textPlaceholder = 'Tell us why' })=>{
    const autoDisappearTimeoutRef = (0, $5uXOq.useRef)(null);
    // only allow a single dismiss for a component
    const isDismissedRef = (0, $5uXOq.useRef)(false);
    const tryDismiss = (0, $5uXOq.useCallback)((trigger)=>{
        // Already called dismiss once
        if (isDismissedRef.current) return;
        isDismissedRef.current = true;
        onDismissRef.current({
            trigger: trigger
        });
    }, []);
    const [currentStep, setCurrentStep] = (0, $5uXOq.useState)('SURVEY');
    const trySetCurrentStep = (0, $5uXOq.useCallback)((step)=>{
        // Already dismissed - cannot update the step
        if (isDismissedRef.current) return;
        setCurrentStep(step);
    }, [
        setCurrentStep
    ]);
    // using a ref so that we don't break all of our caches if a consumer is using an arrow function
    const onDismissRef = (0, $5uXOq.useRef)(onDismiss);
    (0, $5uXOq.useEffect)(()=>{
        onDismissRef.current = onDismiss;
    }, [
        onDismiss
    ]);
    // reset isDismissedRef.current on mount to be compatible with double render in react18 strict mode
    (0, $5uXOq.useEffect)(()=>{
        isDismissedRef.current = false;
    }, []);
    const tryClearTimeout = (0, $5uXOq.useCallback)(()=>{
        const id = autoDisappearTimeoutRef.current;
        if (id) {
            clearTimeout(id);
            autoDisappearTimeoutRef.current = null;
        }
    }, []);
    // Cleanup any auto dismiss after dismiss
    (0, $5uXOq.useEffect)(()=>{
        return function unmount() {
            tryClearTimeout();
            tryDismiss("UNMOUNT");
        };
    }, [
        tryClearTimeout,
        tryDismiss
    ]);
    const onSurveySubmit = (0, $5uXOq.useCallback)(async (formValues, form, callback = ()=>{})=>{
        // Submitting form: Phase 1 complete
        await onSubmit(formValues);
        // Note: need to call callback just before we navigate away
        // It cleans up the form (required)
        // Optional Phase 2: Asking to join Atlassian Research Group
        // Only enter phase 2 if:
        // 1. not already dismissed; AND
        // 2. permission given to contact; AND
        // 3. user has previously not answered mailing list question (getUserHasAnsweredMailingList returns false)
        // Not entering phase 2: User has dismissed while the submit promise was resolving
        if (isDismissedRef.current) {
            callback();
            return;
        }
        // Not entering phase 2: no permission given to respond to feedback
        if (!formValues.canContact) {
            callback();
            trySetCurrentStep('POST_SURVEY_NO_CONSENT');
            return;
        }
        const userHasAnswered = await getUserHasAnsweredMailingList();
        callback();
        // Not entering phase 2: user has already answered this question
        if (userHasAnswered) {
            trySetCurrentStep('POST_SURVEY_HAS_SIGN_UP');
            return;
        }
        // Enter phase 2
        trySetCurrentStep('SIGN_UP_PROMPT');
    }, [
        getUserHasAnsweredMailingList,
        onSubmit,
        trySetCurrentStep
    ]);
    const onMailingListResponse = (0, $5uXOq.useCallback)(async (answer)=>{
        await onMailingListAnswer(answer);
        if (answer) {
            trySetCurrentStep('SIGN_UP_SUCCESS');
            return;
        }
        // We have already thanked to user, we can simply close
        tryDismiss("FINISHED");
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        tryDismiss,
        trySetCurrentStep
    ]);
    // Start the auto disappear when we are finished
    (0, $5uXOq.useEffect)(()=>{
        // Already dismissed
        if (isDismissedRef.current) return;
        // Timeout already scheduled
        if (autoDisappearTimeoutRef.current) return;
        if ([
            'SIGN_UP_SUCCESS',
            'POST_SURVEY_NO_CONSENT',
            'POST_SURVEY_HAS_SIGN_UP'
        ].includes(currentStep)) autoDisappearTimeoutRef.current = window.setTimeout(()=>tryDismiss("AUTO_DISMISS"), $23ee5f706a4214fd$export$3e8963a077f85f25);
    }, [
        currentStep,
        tryDismiss
    ]);
    (0, $9sj5Y.default)({
        onDismiss: ()=>tryDismiss("MANUAL")
    });
    const content = (()=>{
        if (currentStep === 'SURVEY') return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5lQoa.default), {
            question: question,
            statement: statement,
            textLabel: textLabel,
            textPlaceholder: textPlaceholder,
            onSubmit: onSurveySubmit
        });
        if (currentStep === 'SIGN_UP_PROMPT') return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $1OtTj.default), {
            onAnswer: onMailingListResponse
        });
        if (currentStep === 'SIGN_UP_SUCCESS') return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $etgFa.default), {});
        if (currentStep === 'POST_SURVEY_NO_CONSENT' || currentStep === 'POST_SURVEY_HAS_SIGN_UP') return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $lrvs7.default), {});
        return null;
    })();
    const manualDismiss = (0, $5uXOq.useCallback)(()=>{
        // clear any pending timers
        tryClearTimeout();
        tryDismiss("MANUAL");
    }, [
        tryDismiss,
        tryClearTimeout
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $fZZA0.default), {
        onDismiss: manualDismiss,
        children: content
    });
};

});
parcelRegister("lrvs7", function(module, exports) {

$parcel$export(module.exports, "default", () => $910696734eed5546$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $lxMAk = parcelRequire("lxMAk");

var $cldnb = parcelRequire("cldnb");
var $910696734eed5546$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $cldnb.default), {
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $lxMAk.default), {
            size: "xsmall",
            children: "Thanks for your feedback"
        })
    });

});
parcelRegister("cldnb", function(module, exports) {

$parcel$export(module.exports, "default", () => $2ae59681efeeb224$export$2e2bcd8739ae039);
/* SuccessContainer.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $ezrlW = parcelRequire("ezrlW");

const $2ae59681efeeb224$var$sectionStyles = null;
const $2ae59681efeeb224$var$iconContainerStyles = null;
var $2ae59681efeeb224$export$2e2bcd8739ae039 = ({ children: children })=>/*#__PURE__*/ (0, $2OMIu.jsxs)("section", {
        className: (0, $bwpsq.default)([
            "_18u01jfw"
        ]),
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
                className: (0, $bwpsq.default)([
                    "_kqswstnw _154iv47k _1ltv1ejb"
                ]),
                children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($ezrlW))), {
                    spacing: "spacious",
                    label: "",
                    "aria-hidden": true,
                    color: `var(--ds-icon-success, ${(0, $4f06f72592355b39$export$940e1f69e873f202)})`,
                    LEGACY_margin: "4px 0 0 0"
                })
            }),
            children
        ]
    });

});
var $4f06f72592355b39$exports = {};

$parcel$export($4f06f72592355b39$exports, "R50", () => $4f06f72592355b39$export$4b84fd0e2c617bd);
$parcel$export($4f06f72592355b39$exports, "R75", () => $4f06f72592355b39$export$b34b069eff244586);
$parcel$export($4f06f72592355b39$exports, "R100", () => $4f06f72592355b39$export$be802dd0d8b57f35);
$parcel$export($4f06f72592355b39$exports, "R200", () => $4f06f72592355b39$export$60847d42f9da92a6);
$parcel$export($4f06f72592355b39$exports, "R300", () => $4f06f72592355b39$export$4a7404f376229999);
$parcel$export($4f06f72592355b39$exports, "R400", () => $4f06f72592355b39$export$2010d0fb4295b346);
$parcel$export($4f06f72592355b39$exports, "R500", () => $4f06f72592355b39$export$2837b5a1a71d5c02);
$parcel$export($4f06f72592355b39$exports, "Y50", () => $4f06f72592355b39$export$8d9596b529bbb9cf);
$parcel$export($4f06f72592355b39$exports, "Y75", () => $4f06f72592355b39$export$41060a744ab0b7ae);
$parcel$export($4f06f72592355b39$exports, "Y100", () => $4f06f72592355b39$export$1cc05bbbf340e559);
$parcel$export($4f06f72592355b39$exports, "Y200", () => $4f06f72592355b39$export$5aae31392d72caaa);
$parcel$export($4f06f72592355b39$exports, "Y300", () => $4f06f72592355b39$export$c6930421db9fa514);
$parcel$export($4f06f72592355b39$exports, "Y400", () => $4f06f72592355b39$export$59619663aa6500fb);
$parcel$export($4f06f72592355b39$exports, "Y500", () => $4f06f72592355b39$export$874739ea9e379ab6);
$parcel$export($4f06f72592355b39$exports, "G50", () => $4f06f72592355b39$export$8a6341c32b6a3ee6);
$parcel$export($4f06f72592355b39$exports, "G75", () => $4f06f72592355b39$export$69a3bf21b9686c2b);
$parcel$export($4f06f72592355b39$exports, "G100", () => $4f06f72592355b39$export$afbce1382ec95f73);
$parcel$export($4f06f72592355b39$exports, "G200", () => $4f06f72592355b39$export$747d86715d4175de);
$parcel$export($4f06f72592355b39$exports, "G300", () => $4f06f72592355b39$export$940e1f69e873f202);
$parcel$export($4f06f72592355b39$exports, "G400", () => $4f06f72592355b39$export$a49394138f7b8e85);
$parcel$export($4f06f72592355b39$exports, "G500", () => $4f06f72592355b39$export$6fa04827ac68a4fb);
$parcel$export($4f06f72592355b39$exports, "B50", () => $4f06f72592355b39$export$226de0355ed012f8);
$parcel$export($4f06f72592355b39$exports, "B75", () => $4f06f72592355b39$export$8c13c2ee36917869);
$parcel$export($4f06f72592355b39$exports, "B100", () => $4f06f72592355b39$export$ecfc1dff386a3e7a);
$parcel$export($4f06f72592355b39$exports, "B200", () => $4f06f72592355b39$export$215b7063051591f1);
$parcel$export($4f06f72592355b39$exports, "B300", () => $4f06f72592355b39$export$e62e8919cca44969);
$parcel$export($4f06f72592355b39$exports, "B400", () => $4f06f72592355b39$export$b3de0ae08da2ce64);
$parcel$export($4f06f72592355b39$exports, "B500", () => $4f06f72592355b39$export$a6ee3d71bc067634);
$parcel$export($4f06f72592355b39$exports, "B600", () => $4f06f72592355b39$export$67f15409e87642a1);
$parcel$export($4f06f72592355b39$exports, "B700", () => $4f06f72592355b39$export$f0539dbc42dbb067);
$parcel$export($4f06f72592355b39$exports, "P50", () => $4f06f72592355b39$export$363e4475840015bb);
$parcel$export($4f06f72592355b39$exports, "P75", () => $4f06f72592355b39$export$4b0a4417ed59760f);
$parcel$export($4f06f72592355b39$exports, "P100", () => $4f06f72592355b39$export$6011520a64d9a187);
$parcel$export($4f06f72592355b39$exports, "P200", () => $4f06f72592355b39$export$a7175d4e9206bc80);
$parcel$export($4f06f72592355b39$exports, "P300", () => $4f06f72592355b39$export$b48405b95304b5a1);
$parcel$export($4f06f72592355b39$exports, "P400", () => $4f06f72592355b39$export$c71e4279dd54a18d);
$parcel$export($4f06f72592355b39$exports, "P500", () => $4f06f72592355b39$export$147899de772240ec);
$parcel$export($4f06f72592355b39$exports, "T50", () => $4f06f72592355b39$export$2cf711fe14c66f06);
$parcel$export($4f06f72592355b39$exports, "T75", () => $4f06f72592355b39$export$7a8f4d33f6f9772c);
$parcel$export($4f06f72592355b39$exports, "T100", () => $4f06f72592355b39$export$776c9c497ef08533);
$parcel$export($4f06f72592355b39$exports, "T200", () => $4f06f72592355b39$export$69cb3ca10c1e330e);
$parcel$export($4f06f72592355b39$exports, "T300", () => $4f06f72592355b39$export$9dc1ef0f3f48059b);
$parcel$export($4f06f72592355b39$exports, "T400", () => $4f06f72592355b39$export$7c835c78b6fcdef8);
$parcel$export($4f06f72592355b39$exports, "T500", () => $4f06f72592355b39$export$6036577f95c3877e);
$parcel$export($4f06f72592355b39$exports, "N0", () => $4f06f72592355b39$export$29a4f05edc054374);
$parcel$export($4f06f72592355b39$exports, "N10", () => $4f06f72592355b39$export$e655ef011c4aa1a2);
$parcel$export($4f06f72592355b39$exports, "N20", () => $4f06f72592355b39$export$9fdfb749e33cdf97);
$parcel$export($4f06f72592355b39$exports, "N30", () => $4f06f72592355b39$export$3e51e8f1440314ba);
$parcel$export($4f06f72592355b39$exports, "N40", () => $4f06f72592355b39$export$1ce2d1575d444ceb);
$parcel$export($4f06f72592355b39$exports, "N50", () => $4f06f72592355b39$export$8754fc7e6d8b3000);
$parcel$export($4f06f72592355b39$exports, "N60", () => $4f06f72592355b39$export$c2e91cbeada39b8b);
$parcel$export($4f06f72592355b39$exports, "N70", () => $4f06f72592355b39$export$5f71e19f3a7ad9de);
$parcel$export($4f06f72592355b39$exports, "N80", () => $4f06f72592355b39$export$eaa8c8a70ac22806);
$parcel$export($4f06f72592355b39$exports, "N90", () => $4f06f72592355b39$export$7c87d337fb91a97d);
$parcel$export($4f06f72592355b39$exports, "N100", () => $4f06f72592355b39$export$d6447c357493214f);
$parcel$export($4f06f72592355b39$exports, "N200", () => $4f06f72592355b39$export$f563ee71e9ee74cd);
$parcel$export($4f06f72592355b39$exports, "N300", () => $4f06f72592355b39$export$e2ef2124cf4024b1);
$parcel$export($4f06f72592355b39$exports, "N400", () => $4f06f72592355b39$export$eece5f492e429f08);
$parcel$export($4f06f72592355b39$exports, "N500", () => $4f06f72592355b39$export$c39c0fe0f26207ae);
$parcel$export($4f06f72592355b39$exports, "N600", () => $4f06f72592355b39$export$7090862dc3038a9f);
$parcel$export($4f06f72592355b39$exports, "N700", () => $4f06f72592355b39$export$ad0bacf983b7ddaa);
$parcel$export($4f06f72592355b39$exports, "N800", () => $4f06f72592355b39$export$7d61b15e0da132af);
$parcel$export($4f06f72592355b39$exports, "N900", () => $4f06f72592355b39$export$fbda843f0a27fe96);
$parcel$export($4f06f72592355b39$exports, "N10A", () => $4f06f72592355b39$export$791e57b27ca738ef);
$parcel$export($4f06f72592355b39$exports, "N20A", () => $4f06f72592355b39$export$8d43898f60b96a82);
$parcel$export($4f06f72592355b39$exports, "N30A", () => $4f06f72592355b39$export$920c0d5c49070351);
$parcel$export($4f06f72592355b39$exports, "N40A", () => $4f06f72592355b39$export$46987b49aab6d1a8);
$parcel$export($4f06f72592355b39$exports, "N50A", () => $4f06f72592355b39$export$7d3359664e8bb0e5);
$parcel$export($4f06f72592355b39$exports, "N60A", () => $4f06f72592355b39$export$d2d3bedfb276cac0);
$parcel$export($4f06f72592355b39$exports, "N70A", () => $4f06f72592355b39$export$6e5e7499ff054f6d);
$parcel$export($4f06f72592355b39$exports, "N80A", () => $4f06f72592355b39$export$59264b346c877fa7);
$parcel$export($4f06f72592355b39$exports, "N90A", () => $4f06f72592355b39$export$d092757d7c64925c);
$parcel$export($4f06f72592355b39$exports, "N100A", () => $4f06f72592355b39$export$486ab785e4bac3c6);
$parcel$export($4f06f72592355b39$exports, "N200A", () => $4f06f72592355b39$export$fba592bbc6419fea);
$parcel$export($4f06f72592355b39$exports, "N300A", () => $4f06f72592355b39$export$13609db0e6812ab8);
$parcel$export($4f06f72592355b39$exports, "N400A", () => $4f06f72592355b39$export$fbae4efaa892d883);
$parcel$export($4f06f72592355b39$exports, "N500A", () => $4f06f72592355b39$export$f13946d26f440ce6);
$parcel$export($4f06f72592355b39$exports, "N600A", () => $4f06f72592355b39$export$19f58225ac52a306);
$parcel$export($4f06f72592355b39$exports, "N700A", () => $4f06f72592355b39$export$6384f09da70e7b62);
$parcel$export($4f06f72592355b39$exports, "N800A", () => $4f06f72592355b39$export$d0dccc730683edc2);
$parcel$export($4f06f72592355b39$exports, "DN900", () => $4f06f72592355b39$export$2f6319cf7d736c2a);
$parcel$export($4f06f72592355b39$exports, "DN800", () => $4f06f72592355b39$export$95126bc8884d6634);
$parcel$export($4f06f72592355b39$exports, "DN700", () => $4f06f72592355b39$export$8338d8c35d44ff1);
$parcel$export($4f06f72592355b39$exports, "DN600", () => $4f06f72592355b39$export$5368d76ae4fbbda7);
$parcel$export($4f06f72592355b39$exports, "DN500", () => $4f06f72592355b39$export$9f0a771d16ec8d36);
$parcel$export($4f06f72592355b39$exports, "DN400", () => $4f06f72592355b39$export$abcf8c38338b4aa5);
$parcel$export($4f06f72592355b39$exports, "DN300", () => $4f06f72592355b39$export$97e81faa16a182c7);
$parcel$export($4f06f72592355b39$exports, "DN200", () => $4f06f72592355b39$export$bfe21c59123ecf33);
$parcel$export($4f06f72592355b39$exports, "DN100", () => $4f06f72592355b39$export$ee82aa2ea6a1558);
$parcel$export($4f06f72592355b39$exports, "DN90", () => $4f06f72592355b39$export$682927c6ed76be02);
$parcel$export($4f06f72592355b39$exports, "DN80", () => $4f06f72592355b39$export$91fd9994c5be9757);
$parcel$export($4f06f72592355b39$exports, "DN70", () => $4f06f72592355b39$export$d281fbfe3cff2df6);
$parcel$export($4f06f72592355b39$exports, "DN60", () => $4f06f72592355b39$export$3902c91d8b98a753);
$parcel$export($4f06f72592355b39$exports, "DN50", () => $4f06f72592355b39$export$8e8133c1ba5845b5);
$parcel$export($4f06f72592355b39$exports, "DN40", () => $4f06f72592355b39$export$33ff357f6620b39);
$parcel$export($4f06f72592355b39$exports, "DN30", () => $4f06f72592355b39$export$633847cf062b69e0);
$parcel$export($4f06f72592355b39$exports, "DN20", () => $4f06f72592355b39$export$9776a6e503bdbf76);
$parcel$export($4f06f72592355b39$exports, "DN10", () => $4f06f72592355b39$export$6c813d5160dff5db);
$parcel$export($4f06f72592355b39$exports, "DN0", () => $4f06f72592355b39$export$3d4f271a500072a);
$parcel$export($4f06f72592355b39$exports, "DN800A", () => $4f06f72592355b39$export$fe151285c22759ec);
$parcel$export($4f06f72592355b39$exports, "DN700A", () => $4f06f72592355b39$export$a101c6190d0da34);
$parcel$export($4f06f72592355b39$exports, "DN600A", () => $4f06f72592355b39$export$4b16f52932fda51);
$parcel$export($4f06f72592355b39$exports, "DN500A", () => $4f06f72592355b39$export$a74bcd7b9845b0d8);
$parcel$export($4f06f72592355b39$exports, "DN400A", () => $4f06f72592355b39$export$9209c179316d1751);
$parcel$export($4f06f72592355b39$exports, "DN300A", () => $4f06f72592355b39$export$88f55133f636c8dd);
$parcel$export($4f06f72592355b39$exports, "DN200A", () => $4f06f72592355b39$export$51126f85d1009512);
$parcel$export($4f06f72592355b39$exports, "DN100A", () => $4f06f72592355b39$export$a069b547bd23af78);
$parcel$export($4f06f72592355b39$exports, "DN90A", () => $4f06f72592355b39$export$40cce05af3b2600a);
$parcel$export($4f06f72592355b39$exports, "DN80A", () => $4f06f72592355b39$export$b78942185925a0d);
$parcel$export($4f06f72592355b39$exports, "DN70A", () => $4f06f72592355b39$export$e058fb44b8eaafca);
$parcel$export($4f06f72592355b39$exports, "DN60A", () => $4f06f72592355b39$export$92b0b8de26920c18);
$parcel$export($4f06f72592355b39$exports, "DN50A", () => $4f06f72592355b39$export$67564f7459d3fc9e);
$parcel$export($4f06f72592355b39$exports, "DN40A", () => $4f06f72592355b39$export$77868e1ca884ffa3);
$parcel$export($4f06f72592355b39$exports, "DN30A", () => $4f06f72592355b39$export$2afd71d7d3ea2cd5);
$parcel$export($4f06f72592355b39$exports, "DN20A", () => $4f06f72592355b39$export$f2a0acaab9972c70);
$parcel$export($4f06f72592355b39$exports, "DN10A", () => $4f06f72592355b39$export$9ab70e67d6475361);
$parcel$export($4f06f72592355b39$exports, "T30", () => $4f06f72592355b39$export$d2adc5dedf09fced);
$parcel$export($4f06f72592355b39$exports, "L50", () => $4f06f72592355b39$export$f51762073d2bb381);
$parcel$export($4f06f72592355b39$exports, "L75", () => $4f06f72592355b39$export$95e26d54def96891);
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ // Reds
const $4f06f72592355b39$export$4b84fd0e2c617bd = '#FFEBE6';
const $4f06f72592355b39$export$b34b069eff244586 = '#FFBDAD';
const $4f06f72592355b39$export$be802dd0d8b57f35 = '#FF8F73';
const $4f06f72592355b39$export$60847d42f9da92a6 = '#FF7452';
const $4f06f72592355b39$export$4a7404f376229999 = '#FF5630';
const $4f06f72592355b39$export$2010d0fb4295b346 = '#DE350B';
const $4f06f72592355b39$export$2837b5a1a71d5c02 = '#BF2600';
const $4f06f72592355b39$export$8d9596b529bbb9cf = '#FFFAE6';
const $4f06f72592355b39$export$41060a744ab0b7ae = '#FFF0B3';
const $4f06f72592355b39$export$1cc05bbbf340e559 = '#FFE380';
const $4f06f72592355b39$export$5aae31392d72caaa = '#FFC400';
const $4f06f72592355b39$export$c6930421db9fa514 = '#FFAB00';
const $4f06f72592355b39$export$59619663aa6500fb = '#FF991F';
const $4f06f72592355b39$export$874739ea9e379ab6 = '#FF8B00';
const $4f06f72592355b39$export$8a6341c32b6a3ee6 = '#E3FCEF';
const $4f06f72592355b39$export$69a3bf21b9686c2b = '#ABF5D1';
const $4f06f72592355b39$export$afbce1382ec95f73 = '#79F2C0';
const $4f06f72592355b39$export$747d86715d4175de = '#57D9A3';
const $4f06f72592355b39$export$940e1f69e873f202 = '#36B37E';
const $4f06f72592355b39$export$a49394138f7b8e85 = '#00875A';
const $4f06f72592355b39$export$6fa04827ac68a4fb = '#006644';
const $4f06f72592355b39$export$226de0355ed012f8 = '#DEEBFF';
const $4f06f72592355b39$export$8c13c2ee36917869 = '#B3D4FF';
const $4f06f72592355b39$export$ecfc1dff386a3e7a = '#4C9AFF';
const $4f06f72592355b39$export$215b7063051591f1 = '#2684FF';
const $4f06f72592355b39$export$e62e8919cca44969 = '#0065FF';
const $4f06f72592355b39$export$b3de0ae08da2ce64 = '#0052CC';
const $4f06f72592355b39$export$a6ee3d71bc067634 = '#0747A6';
const $4f06f72592355b39$export$67f15409e87642a1 = '#669DF1';
const $4f06f72592355b39$export$f0539dbc42dbb067 = '#8FB8F6';
const $4f06f72592355b39$export$363e4475840015bb = '#EAE6FF';
const $4f06f72592355b39$export$4b0a4417ed59760f = '#C0B6F2';
const $4f06f72592355b39$export$6011520a64d9a187 = '#998DD9';
const $4f06f72592355b39$export$a7175d4e9206bc80 = '#8777D9';
const $4f06f72592355b39$export$b48405b95304b5a1 = '#6554C0';
const $4f06f72592355b39$export$c71e4279dd54a18d = '#5243AA';
const $4f06f72592355b39$export$147899de772240ec = '#403294';
const $4f06f72592355b39$export$2cf711fe14c66f06 = '#E6FCFF';
const $4f06f72592355b39$export$7a8f4d33f6f9772c = '#B3F5FF';
const $4f06f72592355b39$export$776c9c497ef08533 = '#79E2F2';
const $4f06f72592355b39$export$69cb3ca10c1e330e = '#00C7E6';
const $4f06f72592355b39$export$9dc1ef0f3f48059b = '#00B8D9';
const $4f06f72592355b39$export$7c835c78b6fcdef8 = '#00A3BF';
const $4f06f72592355b39$export$6036577f95c3877e = '#008DA6';
const $4f06f72592355b39$export$29a4f05edc054374 = '#FFFFFF';
const $4f06f72592355b39$export$e655ef011c4aa1a2 = '#FAFBFC';
const $4f06f72592355b39$export$9fdfb749e33cdf97 = '#F4F5F7';
const $4f06f72592355b39$export$3e51e8f1440314ba = '#EBECF0';
const $4f06f72592355b39$export$1ce2d1575d444ceb = '#DFE1E6';
const $4f06f72592355b39$export$8754fc7e6d8b3000 = '#C1C7D0';
const $4f06f72592355b39$export$c2e91cbeada39b8b = '#B3BAC5';
const $4f06f72592355b39$export$5f71e19f3a7ad9de = '#A5ADBA';
const $4f06f72592355b39$export$eaa8c8a70ac22806 = '#97A0AF';
const $4f06f72592355b39$export$7c87d337fb91a97d = '#8993A4';
const $4f06f72592355b39$export$d6447c357493214f = '#7A869A';
const $4f06f72592355b39$export$f563ee71e9ee74cd = '#6B778C';
const $4f06f72592355b39$export$e2ef2124cf4024b1 = '#5E6C84';
const $4f06f72592355b39$export$eece5f492e429f08 = '#505F79';
const $4f06f72592355b39$export$c39c0fe0f26207ae = '#42526E';
const $4f06f72592355b39$export$7090862dc3038a9f = '#344563';
const $4f06f72592355b39$export$ad0bacf983b7ddaa = '#253858';
const $4f06f72592355b39$export$7d61b15e0da132af = '#172B4D';
const $4f06f72592355b39$export$fbda843f0a27fe96 = '#091E42';
const $4f06f72592355b39$export$791e57b27ca738ef = 'rgba(9, 30, 66, 0.02)';
const $4f06f72592355b39$export$8d43898f60b96a82 = 'rgba(9, 30, 66, 0.04)';
const $4f06f72592355b39$export$920c0d5c49070351 = 'rgba(9, 30, 66, 0.08)';
const $4f06f72592355b39$export$46987b49aab6d1a8 = 'rgba(9, 30, 66, 0.13)';
const $4f06f72592355b39$export$7d3359664e8bb0e5 = 'rgba(9, 30, 66, 0.25)';
const $4f06f72592355b39$export$d2d3bedfb276cac0 = 'rgba(9, 30, 66, 0.31)';
const $4f06f72592355b39$export$6e5e7499ff054f6d = 'rgba(9, 30, 66, 0.36)';
const $4f06f72592355b39$export$59264b346c877fa7 = 'rgba(9, 30, 66, 0.42)';
const $4f06f72592355b39$export$d092757d7c64925c = 'rgba(9, 30, 66, 0.48)';
const $4f06f72592355b39$export$486ab785e4bac3c6 = 'rgba(9, 30, 66, 0.54)';
const $4f06f72592355b39$export$fba592bbc6419fea = 'rgba(9, 30, 66, 0.60)';
const $4f06f72592355b39$export$13609db0e6812ab8 = 'rgba(9, 30, 66, 0.66)';
const $4f06f72592355b39$export$fbae4efaa892d883 = 'rgba(9, 30, 66, 0.71)';
const $4f06f72592355b39$export$f13946d26f440ce6 = 'rgba(9, 30, 66, 0.77)';
const $4f06f72592355b39$export$19f58225ac52a306 = 'rgba(9, 30, 66, 0.82)';
const $4f06f72592355b39$export$6384f09da70e7b62 = 'rgba(9, 30, 66, 0.89)';
const $4f06f72592355b39$export$d0dccc730683edc2 = 'rgba(9, 30, 66, 0.95)';
const $4f06f72592355b39$export$2f6319cf7d736c2a = '#E6EDFA';
const $4f06f72592355b39$export$95126bc8884d6634 = '#DCE5F5';
const $4f06f72592355b39$export$8338d8c35d44ff1 = '#CED9EB';
const $4f06f72592355b39$export$5368d76ae4fbbda7 = '#B8C7E0';
const $4f06f72592355b39$export$9f0a771d16ec8d36 = '#ABBBD6';
const $4f06f72592355b39$export$abcf8c38338b4aa5 = '#9FB0CC';
const $4f06f72592355b39$export$97e81faa16a182c7 = '#8C9CB8';
const $4f06f72592355b39$export$bfe21c59123ecf33 = '#7988A3';
const $4f06f72592355b39$export$ee82aa2ea6a1558 = '#67758F';
const $4f06f72592355b39$export$682927c6ed76be02 = '#56637A';
const $4f06f72592355b39$export$91fd9994c5be9757 = '#455166';
const $4f06f72592355b39$export$d281fbfe3cff2df6 = '#3B475C';
const $4f06f72592355b39$export$3902c91d8b98a753 = '#313D52';
const $4f06f72592355b39$export$8e8133c1ba5845b5 = '#283447';
const $4f06f72592355b39$export$33ff357f6620b39 = '#202B3D';
const $4f06f72592355b39$export$633847cf062b69e0 = '#1B2638';
const $4f06f72592355b39$export$9776a6e503bdbf76 = '#121A29';
const $4f06f72592355b39$export$6c813d5160dff5db = '#0E1624';
const $4f06f72592355b39$export$3d4f271a500072a = '#0D1424';
const $4f06f72592355b39$export$fe151285c22759ec = 'rgba(13, 20, 36, 0.06)';
const $4f06f72592355b39$export$a101c6190d0da34 = 'rgba(13, 20, 36, 0.14)';
const $4f06f72592355b39$export$4b16f52932fda51 = 'rgba(13, 20, 36, 0.18)';
const $4f06f72592355b39$export$a74bcd7b9845b0d8 = 'rgba(13, 20, 36, 0.29)';
const $4f06f72592355b39$export$9209c179316d1751 = 'rgba(13, 20, 36, 0.36)';
const $4f06f72592355b39$export$88f55133f636c8dd = 'rgba(13, 20, 36, 0.40)';
const $4f06f72592355b39$export$51126f85d1009512 = 'rgba(13, 20, 36, 0.47)';
const $4f06f72592355b39$export$a069b547bd23af78 = 'rgba(13, 20, 36, 0.53)';
const $4f06f72592355b39$export$40cce05af3b2600a = 'rgba(13, 20, 36, 0.63)';
const $4f06f72592355b39$export$b78942185925a0d = 'rgba(13, 20, 36, 0.73)';
const $4f06f72592355b39$export$e058fb44b8eaafca = 'rgba(13, 20, 36, 0.78)';
const $4f06f72592355b39$export$92b0b8de26920c18 = 'rgba(13, 20, 36, 0.81)';
const $4f06f72592355b39$export$67564f7459d3fc9e = 'rgba(13, 20, 36, 0.85)';
const $4f06f72592355b39$export$77868e1ca884ffa3 = 'rgba(13, 20, 36, 0.89)';
const $4f06f72592355b39$export$2afd71d7d3ea2cd5 = 'rgba(13, 20, 36, 0.92)';
const $4f06f72592355b39$export$f2a0acaab9972c70 = 'rgba(13, 20, 36, 0.95)';
const $4f06f72592355b39$export$9ab70e67d6475361 = 'rgba(13, 20, 36, 0.97)';
const $4f06f72592355b39$export$d2adc5dedf09fced = '#292A2E';
const $4f06f72592355b39$export$f51762073d2bb381 = '#94C748';
const $4f06f72592355b39$export$95e26d54def96891 = '#B3DF72';



parcelRegister("1OtTj", function(module, exports) {

$parcel$export(module.exports, "default", () => $5f28b53e2b938135$export$2e2bcd8739ae039);
/* SignUpPrompt.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $47t9U = parcelRequire("47t9U");

var $lxMAk = parcelRequire("lxMAk");

var $2FWsO = parcelRequire("2FWsO");

var $70ITn = parcelRequire("70ITn");
var $eBiLk = parcelRequire("eBiLk");
var $du3Kd = parcelRequire("du3Kd");

var $cldnb = parcelRequire("cldnb");
const $5f28b53e2b938135$var$buttonContainerStyles = null;
var $5f28b53e2b938135$export$2e2bcd8739ae039 = ({ onAnswer: onAnswer })=>{
    const [pending, setPending] = (0, $5uXOq.useState)(null);
    const answeredWith = (0, $5uXOq.useCallback)(async (answer)=>{
        setPending(answer ? 'yes' : 'no');
        await onAnswer(answer);
    }, [
        setPending,
        onAnswer
    ]);
    const isDisabled = Boolean(pending);
    return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $cldnb.default), {
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $lxMAk.default), {
                size: "xsmall",
                children: "Thanks for your feedback"
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $70ITn.default), {
                paddingBlockStart: "space.150",
                children: /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $eBiLk.default), {
                    space: "space.150",
                    children: [
                        /*#__PURE__*/ (0, $2OMIu.jsx)((0, $du3Kd.default), {
                            as: "p",
                            children: "Are you interested in participating in our research?"
                        }),
                        /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $du3Kd.default), {
                            as: "p",
                            children: [
                                "Sign up for the",
                                ' ',
                                /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2FWsO.default), {
                                    href: "https://www.atlassian.com/research-group",
                                    target: "_blank",
                                    children: "Atlassian Research Group"
                                }),
                                ' ',
                                "and we may contact you in the future with research opportunities."
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $2OMIu.jsxs)("div", {
                className: (0, $bwpsq.default)([
                    "_19pkxy5q _1e0c1txw _1bahesu3 _pof3u2gc"
                ]),
                children: [
                    /*#__PURE__*/ (0, $2OMIu.jsx)((0, $47t9U.default), {
                        appearance: "subtle",
                        onClick: ()=>answeredWith(false),
                        isDisabled: isDisabled,
                        isLoading: pending === 'no',
                        children: "No, thanks"
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsx)((0, $47t9U.default), {
                        appearance: "primary",
                        onClick: ()=>answeredWith(true),
                        isDisabled: isDisabled,
                        isLoading: pending === 'yes',
                        children: "Yes, sign me up"
                    })
                ]
            })
        ]
    });
};

});

parcelRegister("etgFa", function(module, exports) {

$parcel$export(module.exports, "default", () => $f0b57ee0be2f365a$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $lxMAk = parcelRequire("lxMAk");

var $eBiLk = parcelRequire("eBiLk");
var $du3Kd = parcelRequire("du3Kd");

var $cldnb = parcelRequire("cldnb");
var $f0b57ee0be2f365a$export$2e2bcd8739ae039 = ({})=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $cldnb.default), {
        children: /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $eBiLk.default), {
            space: "space.150",
            children: [
                /*#__PURE__*/ (0, $2OMIu.jsx)((0, $lxMAk.default), {
                    size: "xsmall",
                    children: "Thanks for signing up"
                }),
                /*#__PURE__*/ (0, $2OMIu.jsx)((0, $du3Kd.default), {
                    as: "p",
                    children: "We may reach out to you in the future to participate in additional research."
                })
            ]
        })
    });

});

parcelRegister("fZZA0", function(module, exports) {

$parcel$export(module.exports, "default", () => $c4a799f10a9ea9aa$export$2e2bcd8739ae039);
/* SurveyContainer.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $4zsnF = parcelRequire("4zsnF");

var $3fgs9 = parcelRequire("3fgs9");
const $c4a799f10a9ea9aa$var$containerStyles = null;
const $c4a799f10a9ea9aa$var$buttonWrapperStyles = null;
var $c4a799f10a9ea9aa$export$2e2bcd8739ae039 = ({ children: children, onDismiss: onDismiss })=>{
    return /*#__PURE__*/ (0, $2OMIu.jsxs)("div", {
        style: {},
        className: (0, $bwpsq.default)([
            "_2rko1sit _bfhk1bhr _ca0q1ejb _u5f31ejb _n3td1ejb _19bv1ejb _16qshynm _1bsb1vif"
        ]),
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
                className: (0, $bwpsq.default)([
                    "_kqswstnw _154ipxbi _1xi2pxbi"
                ]),
                children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $4zsnF.default), {
                    icon: (0, (/*@__PURE__*/$parcel$interopDefault($3fgs9))),
                    label: "Dismiss",
                    appearance: "subtle",
                    onClick: onDismiss
                })
            }),
            children
        ]
    });
};

});

parcelRegister("5lQoa", function(module, exports) {

$parcel$export(module.exports, "default", () => $0e88378428864b81$export$2e2bcd8739ae039);
/* SurveyForm.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $ahdj0 = parcelRequire("ahdj0");

var $47t9U = parcelRequire("47t9U");

var $az9GY = parcelRequire("az9GY");

var $74kBa = parcelRequire("74kBa");
var $4tW0z = parcelRequire("4tW0z");
var $13Saz = parcelRequire("13Saz");
var $1rKpn = parcelRequire("1rKpn");

var $lxMAk = parcelRequire("lxMAk");

var $eBiLk = parcelRequire("eBiLk");
var $du3Kd = parcelRequire("du3Kd");

var $9t5oA = parcelRequire("9t5oA");

var $5Ud9O = parcelRequire("5Ud9O");
const $0e88378428864b81$var$transitionBaseStyles = null;
const $0e88378428864b81$var$getExpandedHeight = (ref, state)=>{
    if (!ref.current) return '0';
    switch(state){
        case 'entering':
            return `${ref.current.scrollHeight}px`;
        case 'entered':
            // needed for TextField auto height expand
            return `none`;
        default:
            return '0';
    }
};
const $0e88378428864b81$var$transitionDuration = 200;
var $0e88378428864b81$export$2e2bcd8739ae039 = ({ question: question, statement: statement, textPlaceholder: textPlaceholder, textLabel: textLabel, onSubmit: onSubmit })=>{
    const [expanded, setExpanded] = (0, $5uXOq.useState)(false);
    const [canContactDefault, setCanContactDefault] = (0, $5uXOq.useState)(false);
    const hasAutoFilledCanContactRef = (0, $5uXOq.useRef)(false);
    const expandedAreaRef = (0, $5uXOq.useRef)(null);
    const onScoreSelect = (0, $5uXOq.useCallback)(()=>{
        setExpanded(true);
    }, [
        setExpanded
    ]);
    // On the first type the user types some feedback we auto select
    // the option for allowing feedback. This automatic selection only
    // happens once. After that it is up to the user to control
    const onFeedbackChange = (0, $5uXOq.useCallback)(()=>{
        if (hasAutoFilledCanContactRef.current) return;
        hasAutoFilledCanContactRef.current = true;
        setCanContactDefault(true);
    }, []);
    return /*#__PURE__*/ (0, $2OMIu.jsxs)("section", {
        "aria-labelledby": "contextualSurveyQuestion",
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $eBiLk.default), {
                space: "space.150",
                children: [
                    /*#__PURE__*/ (0, $2OMIu.jsx)((0, $lxMAk.default), {
                        id: "contextualSurveyQuestion",
                        size: "xsmall",
                        children: question
                    }),
                    statement && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $du3Kd.default), {
                        as: "p",
                        id: "contextualSurveyStatement",
                        children: statement
                    })
                ]
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $4tW0z.default), {
                onSubmit: onSubmit,
                children: ({ formProps: formProps, submitting: submitting })=>/*#__PURE__*/ (0, $2OMIu.jsxs)("form", {
                        ...formProps,
                        children: [
                            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $13Saz.default), {
                                name: "feedbackScore",
                                isDisabled: submitting,
                                isRequired: true,
                                children: ({ fieldProps: fieldProps })=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $5Ud9O.default), {
                                        ...fieldProps,
                                        onChange: (score)=>{
                                            fieldProps.onChange(score);
                                            onScoreSelect();
                                        }
                                    })
                            }),
                            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ahdj0.default), {
                                in: expanded,
                                timeout: $0e88378428864b81$var$transitionDuration,
                                mountOnEnter: true,
                                children: (state)=>/*#__PURE__*/ (0, $2OMIu.jsxs)("div", {
                                        style: {
                                            transition: `max-height ${$0e88378428864b81$var$transitionDuration}ms ease-in-out`,
                                            maxHeight: $0e88378428864b81$var$getExpandedHeight(expandedAreaRef, state)
                                        },
                                        ref: expandedAreaRef,
                                        className: (0, $bwpsq.default)([
                                            "_1reo15vq _18m915vq"
                                        ]),
                                        children: [
                                            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $13Saz.default), {
                                                name: "writtenFeedback",
                                                defaultValue: "",
                                                isDisabled: submitting,
                                                children: ({ fieldProps: fieldProps })=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $9t5oA.default), {
                                                        ...fieldProps,
                                                        "aria-label": textLabel,
                                                        placeholder: textPlaceholder,
                                                        onChange: (event)=>{
                                                            fieldProps.onChange(event);
                                                            onFeedbackChange();
                                                        }
                                                    })
                                            }),
                                            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $74kBa.default), {
                                                name: "canContact",
                                                isDisabled: submitting,
                                                defaultIsChecked: canContactDefault,
                                                children: ({ fieldProps: fieldProps })=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $az9GY.default), {
                                                        ...fieldProps,
                                                        label: "Atlassian can contact me about this feedback"
                                                    })
                                            }),
                                            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $1rKpn.default), {
                                                children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $47t9U.default), {
                                                    type: "submit",
                                                    appearance: "primary",
                                                    isLoading: submitting,
                                                    children: "Submit"
                                                })
                                            })
                                        ]
                                    })
                            })
                        ]
                    })
            })
        ]
    });
};

});
parcelRegister("az9GY", function(module, exports) {

$parcel$export(module.exports, "default", () => $87578ebbf2172823$export$2e2bcd8739ae039);
/* checkbox.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $9v1CN = parcelRequire("9v1CN");

var $6L31F = parcelRequire("6L31F");

var $lUXib = parcelRequire("lUXib");
var $jx7SA = parcelRequire("jx7SA");
var $eJ66I = parcelRequire("eJ66I");
var $056Y9 = parcelRequire("056Y9");
const $87578ebbf2172823$var$checkboxStyles = null; /**
                              * __Checkbox__
                              *
                              * A checkbox an input control that allows a user to select one or more options from a number of choices.
                              *
                              * - [Examples](https://atlassian.design/components/checkbox/examples)
                              * - [Code](https://atlassian.design/components/checkbox/code)
                              * - [Usage](https://atlassian.design/components/checkbox/usage)
                              */ 
const $87578ebbf2172823$var$Checkbox = /*#__PURE__*/ (0, $5uXOq.memo)(/*#__PURE__*/ (0, $5uXOq.forwardRef)(function Checkbox({ isChecked: isCheckedProp, isDisabled: isDisabled = false, isInvalid: isInvalid = false, defaultChecked: defaultChecked = false, isIndeterminate: isIndeterminate = false, onChange: onChangeProps, analyticsContext: analyticsContext, label: label, name: name, value: value, isRequired: isRequired, testId: testId, xcss: xcss, className: className, ...rest }, ref) {
    const [isCheckedState, setIsCheckedState] = (0, $5uXOq.useState)(isCheckedProp !== undefined ? isCheckedProp : defaultChecked);
    const onChange = (0, $5uXOq.useCallback)((e, analyticsEvent)=>{
        setIsCheckedState(e.target.checked);
        if (onChangeProps) onChangeProps(e, analyticsEvent);
    }, [
        onChangeProps
    ]);
    const onChangeAnalytics = (0, $9v1CN.usePlatformLeafEventHandler)({
        fn: onChange,
        action: 'changed',
        analyticsData: analyticsContext,
        componentName: 'checkbox',
        packageName: "platform-pkg",
        packageVersion: "0.0.0-use.local"
    });
    const internalRef = (0, $5uXOq.useRef)(null);
    const mergedRefs = (0, $6L31F.default)([
        internalRef,
        ref
    ]); // Use isChecked from the state if it is controlled
    const isChecked = isCheckedProp === undefined ? isCheckedState : isCheckedProp;
    (0, $5uXOq.useEffect)(()=>{
        if (internalRef.current) internalRef.current.indeterminate = isIndeterminate;
    }, [
        isIndeterminate
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $jx7SA.default), {
        isDisabled: isDisabled,
        label: label,
        id: rest.id ? `${rest.id}-label` : undefined,
        testId: testId && `${testId}--checkbox-label`,
        // When there is more usage of this pattern we'll update the lint rule.
        xcss: xcss,
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)("input" // It is necessary only for Safari. It allows to render focus styles.
            , {
                tabIndex: 0,
                ...rest,
                type: "checkbox",
                ref: mergedRefs,
                disabled: isDisabled,
                checked: isChecked,
                value: value,
                name: name,
                required: isRequired,
                className: (0, $bwpsq.default)([
                    "_19itglyw _nd5lfibj _12ji1r31 _1qu2glyw _12y31o36 _1bsb1osq _4t3i1osq _r06hglyw _6rthze3t _1pfhze3t _12l2ze3t _ahbqze3t _tzy4idpf _r050fibj _9bg71mn3 _19op11so _a30fhteq _1610e4h9 _13wo93zu _q5a61gyf _8gq114p8 _wje2mov0 _1fo21cni _eyedglyw _1ef7js4s _1h6rjs4s _smzgj3jf _1dk7j3jf _l71j1i6y _t34a1i6y _y32gkivo _1ah9199y _1frj180l _h78e1g3k _dwvb1ps2 _1bok170n _1mhr17cl _fx2i3rva _10oaq2ws _w12s155b _15y61vek _e6ww155b _sg1j1vek _rphw18jz _y9y9mz2b _141bmz2b _255gmz2b _jj67mz2b _swhgmz2b _axq81diq _1jiz1diq _s9051diq _1efy1diq _1oav1diq _10y313gf _1wt913gf _qq8613gf _1adw13gf _12sr13gf _16jiglyw _693jglyw _1niqglyw _cl9tglyw _1jbnglyw _j1ta1hou _18qu1ps2 _1g52170n _1log17cl _32hzmz2b _1vv91diq _yjhd1hou _w1cowc43 _jdqn1onz _4y4t1onz _lvfrwc43 _g68dwc43 _13dk1onz _w1el1onz _a9yw1onz _1l3g1onz _dcdpgir2 _wobcgir2 _rp9wgir2 _9ebfwc43 _e43iwc43 _1tkuwc43 _1lehwc43 _b9q3wc43 _tu2918qt _1uxv18qt _1ufw18qt _opo918qt _1e8318qt _1k3d18qt _25yv18qt _1igz18qt _c7cc18qt _1swg18qt",
                    className
                ]),
                onChange: onChangeAnalytics,
                "aria-invalid": isInvalid ? 'true' : undefined,
                "data-testid": testId && `${testId}--hidden-checkbox`,
                "data-invalid": isInvalid ? 'true' : undefined
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $lUXib.default), {
                isIndeterminate: isIndeterminate,
                isChecked: isChecked
            }),
            label && /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $eJ66I.default), {
                children: [
                    label,
                    isRequired && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $056Y9.default), {})
                ]
            })
        ]
    });
}));
$87578ebbf2172823$var$Checkbox.displayName = 'Checkbox';
var $87578ebbf2172823$export$2e2bcd8739ae039 = $87578ebbf2172823$var$Checkbox;

});
parcelRegister("lUXib", function(module, exports) {

$parcel$export(module.exports, "default", () => $f840b2bb9dae27dc$export$2e2bcd8739ae039);
/* checkbox-icon.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $i3kwn = parcelRequire("i3kwn");

var $iYZCl = parcelRequire("iYZCl");
function $f840b2bb9dae27dc$var$getIcon(isIndeterminate, isChecked) {
    if (isIndeterminate) {
        // eslint-disable-next-line @atlaskit/platform/no-preconditioning, @atlaskit/platform/ensure-feature-flag-prefix
        if ((0, $iYZCl.fg)('platform-visual-refresh-icons') && (0, $iYZCl.fg)('platform-icon-control-migration')) return /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M7.75 12.75H16.25V11.25H7.75V12.75Z",
            fill: "inherit"
        });
        else return /*#__PURE__*/ (0, $2OMIu.jsx)("rect", {
            fill: "inherit",
            x: "8",
            y: "11",
            width: "8",
            height: "2",
            rx: "1"
        });
    }
    if (isChecked) {
        // eslint-disable-next-line @atlaskit/platform/no-preconditioning, @atlaskit/platform/ensure-feature-flag-prefix
        if ((0, $iYZCl.fg)('platform-visual-refresh-icons') && (0, $iYZCl.fg)('platform-icon-control-migration')) return /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M16.3262 9.48011L15.1738 8.51984L10.75 13.8284L8.82616 11.5198L7.67383 12.4801L10.1738 15.4801C10.3163 15.6511 10.5274 15.75 10.75 15.75C10.9726 15.75 11.1837 15.6511 11.3262 15.4801L16.3262 9.48011Z",
            fill: "inherit"
        });
        else return /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
            d: "M9.707 11.293a1 1 0 1 0-1.414 1.414l2 2a1 1 0 0 0 1.414 0l4-4a1 1 0 1 0-1.414-1.414L11 12.586l-1.293-1.293z",
            fill: "inherit"
        });
    }
    // No icon
    return null;
}
/**
 * __Checkbox icon__
 *
 * A checkbox icon is the visual representation of checkbox state,
 * which is shown instead of the native input.
 *
 * @internal
 */ const $f840b2bb9dae27dc$var$CheckboxIcon = /*#__PURE__*/ (0, $5uXOq.memo)(({ isIndeterminate: isIndeterminate, isChecked: isChecked })=>{
    const icon = (0, $5uXOq.useMemo)(()=>$f840b2bb9dae27dc$var$getIcon(isIndeterminate, isChecked), [
        isIndeterminate,
        isChecked
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $i3kwn.default), {
        label: "",
        primaryColor: "var(--checkbox-background-color)",
        secondaryColor: "var(--checkbox-tick-color)",
        children: /*#__PURE__*/ (0, $2OMIu.jsxs)("g", {
            fillRule: "evenodd",
            children: [
                // eslint-disable-next-line @atlaskit/platform/no-preconditioning, @atlaskit/platform/ensure-feature-flag-prefix
                (0, $iYZCl.fg)('platform-visual-refresh-icons') && (0, $iYZCl.fg)('platform-icon-control-migration') ? /*#__PURE__*/ (0, $2OMIu.jsx)("rect", {
                    fill: "currentColor",
                    x: "5.5",
                    y: "5.5",
                    width: "13",
                    height: "13",
                    rx: "1.5"
                }) : /*#__PURE__*/ (0, $2OMIu.jsx)("rect", {
                    fill: "currentColor",
                    x: "6",
                    y: "6",
                    width: "12",
                    height: "12",
                    rx: "2"
                }),
                icon
            ]
        })
    });
});
var $f840b2bb9dae27dc$export$2e2bcd8739ae039 = $f840b2bb9dae27dc$var$CheckboxIcon;

});

parcelRegister("jx7SA", function(module, exports) {

$parcel$export(module.exports, "default", () => $9a0731ccf498cf6e$export$2e2bcd8739ae039);
/* label.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
const $9a0731ccf498cf6e$var$baseStyles = null;
const $9a0731ccf498cf6e$var$textLabelLayoutStyles = null;
const $9a0731ccf498cf6e$var$disabledStyles = null;
const $9a0731ccf498cf6e$var$labelStyles = null;
function $9a0731ccf498cf6e$export$2e2bcd8739ae039({ children: children, isDisabled: isDisabled, testId: testId, label: label, id: id, xcss: xcss }) {
    return /*#__PURE__*/ (0, $2OMIu.jsx)("label", {
        className: (0, $bwpsq.default)([
            "_11c82smr _1e0c11p5 _1ejihkll _umai184x _syazj3m3 _80om73ad",
            label && "_zulp1nu5 _yv0ey09t",
            isDisabled && "_syaz1tvo _80om13gf",
            "_h5e3mag2 _1nzs11d3 _1eszzyvw _yp0jhh5a _ay2w1y1w _d51u10ko _phft1fmg _1g1funzk _l6wkzyvw _1dikhh5a _1sfg1q3k _fpdj1y1w _1yjc194a _oaj11fmg _1j3h1q3k _eawb1dzn _1rda1qbb _18q015t7 _13hr3acm",
            xcss
        ]),
        "data-testid": testId,
        "data-disabled": isDisabled || undefined,
        id: id,
        children: children
    });
}

});

parcelRegister("eJ66I", function(module, exports) {

$parcel$export(module.exports, "default", () => $ec7249cc31498c58$export$2e2bcd8739ae039);
/* label-text.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
const $ec7249cc31498c58$var$labelTextStyles = null;
function $ec7249cc31498c58$export$2e2bcd8739ae039({ children: children }) {
    return /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
        className: (0, $bwpsq.default)([
            "_nd5l11ig _1wpz1h6o"
        ]),
        children: children
    });
}

});

parcelRegister("056Y9", function(module, exports) {

$parcel$export(module.exports, "default", () => $2dcec527645644aa$export$2e2bcd8739ae039);
/* required-indicator.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
const $2dcec527645644aa$var$requiredIndicatorStyles = null;
function $2dcec527645644aa$export$2e2bcd8739ae039() {
    return /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
        "aria-hidden": true,
        className: (0, $bwpsq.default)([
            "_syaz1gtz _bozgv77o"
        ]),
        children: "*"
    });
}

});


parcelRegister("74kBa", function(module, exports) {

$parcel$export(module.exports, "default", () => $04af5ff1474d41dd$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $13Saz = parcelRequire("13Saz");
/**
 * __Checkbox field__
 *
 * A checkbox field is a form field that lets users select an item. Users can check or uncheck the checkbox.
 *
 * - [Examples] https://atlaskit.atlassian.com/packages/design-system/form/docs/fields#checkboxfield-reference
 * - [Code] https://atlaskit.atlassian.com/packages/design-system/form/docs/fields#checkboxfield-reference
 * - [Usage] https://atlaskit.atlassian.com/packages/design-system/form/docs/fields#checkboxfield-reference
 */ const $04af5ff1474d41dd$var$CheckboxField = (props)=>{
    const { children: children, defaultIsChecked: defaultIsChecked = false, value: value, ...rest } = props;
    // Maintains a memoised list of the default values
    const defaultValue = (0, $5uXOq.useCallback)((currentValue = [])=>defaultIsChecked && value !== undefined ? [
            ...currentValue,
            value
        ] : currentValue, [
        value,
        defaultIsChecked
    ]);
    return value !== undefined ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $13Saz.default), {
        ...rest,
        defaultValue: defaultValue,
        transform: (event, currentValue)=>event.currentTarget.checked && currentValue ? [
                ...currentValue,
                value
            ] : currentValue.filter((v)=>v !== value),
        children: ({ fieldProps: { value: fieldValue, ...otherFieldProps }, ...others })=>children({
                fieldProps: {
                    ...otherFieldProps,
                    isChecked: !!fieldValue.find((v)=>v === value),
                    value: value
                },
                ...others
            })
    }) : /*#__PURE__*/ (0, $2OMIu.jsx)((0, $13Saz.default), {
        ...rest,
        defaultValue: defaultIsChecked,
        transform: (event)=>event.currentTarget.checked,
        children: ({ fieldProps: { value: fieldValue, ...otherFieldProps }, ...others })=>children({
                fieldProps: {
                    ...otherFieldProps,
                    isChecked: fieldValue,
                    value: value
                },
                ...others
            })
    });
};
$04af5ff1474d41dd$var$CheckboxField.defaultProps = {
    defaultIsChecked: false
};
var $04af5ff1474d41dd$export$2e2bcd8739ae039 = $04af5ff1474d41dd$var$CheckboxField;

});
parcelRegister("13Saz", function(module, exports) {

$parcel$export(module.exports, "default", () => $263f770518f87e95$export$2e2bcd8739ae039);
/* field.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
parcelRequire("3joPi");

var $5KvHB = parcelRequire("5KvHB");

var $gEL5P = parcelRequire("gEL5P");

var $4tW0z = parcelRequire("4tW0z");

var $4utXj = parcelRequire("4utXj");

var $8TOd3 = parcelRequire("8TOd3");

var $6cAn5 = parcelRequire("6cAn5");
const $263f770518f87e95$var$fieldWrapperStyles = null;
function $263f770518f87e95$var$isEvent(event) {
    return Boolean(event && event.target);
}
function $263f770518f87e95$var$isFunction(x) {
    return typeof x === 'function';
}
function $263f770518f87e95$var$usePreviousRef(current) {
    const ref = (0, $5uXOq.useRef)(current);
    // will be updated on the next render
    (0, $5uXOq.useEffect)(()=>{
        ref.current = current;
    });
    // return the existing current (pre render)
    return ref;
}
function $263f770518f87e95$var$isShallowEqual(previousValue, currentValue) {
    if (previousValue === currentValue) return true;
    // not checking functions
    if (typeof previousValue === 'function' && typeof currentValue === 'function') return true;
    if (Array.isArray(previousValue) && Array.isArray(currentValue)) return JSON.stringify(previousValue) === JSON.stringify(currentValue);
    if (typeof previousValue === 'object' && typeof currentValue === 'object') return JSON.stringify(previousValue) === JSON.stringify(currentValue);
    return false;
}
function $263f770518f87e95$export$2e2bcd8739ae039(props) {
    const { registerField: registerField, getCurrentValue: getCurrentValue } = (0, $5uXOq.useContext)((0, $4tW0z.FormContext));
    const isDisabled = (0, $5uXOq.useContext)((0, $4tW0z.IsDisabledContext)) || props.isDisabled || false;
    const defaultValue = $263f770518f87e95$var$isFunction(props.defaultValue) ? props.defaultValue() : props.defaultValue;
    const latestPropsRef = $263f770518f87e95$var$usePreviousRef(props);
    /**
   * HACK: defaultValue can potentially be an array or object which cannot be
   * passed directly into a `useEffect` dependency array, since it will trigger
   * the hook every time.
   */ const isDefaultValueChanged = !$263f770518f87e95$var$isShallowEqual(latestPropsRef.current.defaultValue, props.defaultValue);
    const [state, setState] = (0, $5uXOq.useState)({
        fieldProps: {
            onChange: ()=>{},
            onBlur: ()=>{},
            onFocus: ()=>{},
            /* Previously, defaultValue was being set as undefined in Field.defaultProps, which
       * effectively made it an optional prop to external consumers of Field. However the
       * prop types defined defaultValue as required, so inside the component it was not
       * valid for defaultValue to be undefined. We need to suppress the error
       * after changing defaultValue to explicitly be an optional prop.
       * If default value has changed we are using new default value.
       * Otherwise we need to check if we already have value for this field
       * (because we are using changing key prop to re-run field level validation, and that
       * cause the component re-mounting) to not override the actual value with the default value.
       */ // @ts-ignore
            value: isDefaultValueChanged ? defaultValue : getCurrentValue(props.name) ?? defaultValue
        },
        error: undefined,
        valid: false,
        meta: {
            dirty: false,
            dirtySinceLastSubmit: false,
            touched: false,
            valid: false,
            validating: false,
            submitting: false,
            submitFailed: false,
            error: undefined,
            submitError: undefined
        }
    });
    const latestStateRef = $263f770518f87e95$var$usePreviousRef(state);
    (0, $5uXOq.useEffect)(()=>{
        typeof $6cAn5;
        function fieldStateToMeta(value = {}) {
            return {
                dirty: value.dirty || false,
                dirtySinceLastSubmit: value.dirtySinceLastSubmit || false,
                touched: value.touched || false,
                valid: value.valid || false,
                submitting: value.submitting || false,
                submitFailed: value.submitFailed || false,
                error: value.error,
                submitError: value.submitError,
                validating: !!value.validating
            };
        }
        const unregister = registerField(latestPropsRef.current.name, /**
     * Similar as for setting initial state value.
     * Additionally we are checking if the default value is a function,
     * it is used in checkbox fields, where fields with same name and
     * defaultIsChecked should create array of values. In this situation we can't
     * override the default value on re-registering, but also we don't need to change
     * the key prop to re-run validation.
     */ // @ts-ignore
        isDefaultValueChanged || // @ts-ignore
        $263f770518f87e95$var$isFunction(latestPropsRef.current.defaultValue) ? latestPropsRef.current.defaultValue : latestStateRef.current.fieldProps.value, (fieldState)=>{
            /**
       * Do not update dirtySinceLastSubmit until submission has finished.
       */ const modifiedDirtySinceLastSubmit = fieldState.submitting ? latestStateRef.current.meta.dirtySinceLastSubmit : fieldState.dirtySinceLastSubmit;
            /**
       * Do not update submitFailed until submission has finished.
       */ const modifiedSubmitFailed = fieldState.submitting ? latestStateRef.current.meta.submitFailed : fieldState.submitFailed;
            /**
       * Do not use submitError if the value has changed.
       */ const modifiedSubmitError = modifiedDirtySinceLastSubmit && latestPropsRef.current.validate ? undefined : fieldState.submitError;
            const modifiedError = modifiedSubmitError || (fieldState.touched || fieldState.dirty) && fieldState.error;
            /**
       * If there has been a submit error, then use logic in modifiedError to determine validity,
       * so we can determine when there is a submit error which we do not want to display
       * because the value has been changed.
       */ const modifiedValid = modifiedSubmitFailed ? modifiedError === undefined : fieldState.valid;
            function getTransform(eventOrValue, currentValue) {
                if (latestPropsRef.current.transform) return latestPropsRef.current.transform(eventOrValue, currentValue);
                if ($263f770518f87e95$var$isEvent(eventOrValue)) {
                    const { currentTarget: currentTarget } = eventOrValue;
                    if (currentTarget.type === 'checkbox') {
                        if (currentTarget.checked) return currentTarget.value || true;
                        return currentTarget.value ? undefined : false;
                    } else if (currentTarget) return currentTarget.value;
                } else return eventOrValue;
            }
            setState({
                fieldProps: {
                    onChange: (e)=>{
                        fieldState.change(getTransform(e, fieldState.value));
                    },
                    onBlur: fieldState.blur,
                    onFocus: fieldState.focus,
                    value: fieldState.value
                },
                error: modifiedError || undefined,
                /**
         * The following parameters are optionally typed in final-form to indicate that not all parameters need
         * to be subscribed to. We cast them as booleans (using || false), since this is what they are semantically.
         */ valid: modifiedValid || false,
                meta: fieldStateToMeta(fieldState)
            });
        }, {
            dirty: true,
            dirtySinceLastSubmit: true,
            touched: true,
            valid: true,
            submitting: true,
            submitFailed: true,
            value: true,
            error: true,
            submitError: true,
            validating: true
        }, {
            getValidator: ()=>function validate(value, formState, fieldState) {
                    const supplied = latestPropsRef.current.validate;
                    if (supplied && fieldState) return supplied(value, formState, fieldStateToMeta(fieldState));
                }
        });
        return unregister;
    }, [
        latestPropsRef,
        latestStateRef,
        registerField,
        props.name,
        isDefaultValueChanged
    ]);
    const uid = (0, $5KvHB.useId)();
    const fieldId = (0, $5uXOq.useMemo)(()=>{
        return props.id ? props.id : `${props.name}-${uid}`;
    }, [
        props.id,
        props.name,
        uid
    ]);
    const getDescribedBy = ()=>{
        let value = '';
        if (state.error) value += `${fieldId}-error `;
        if (state.valid) value += `${fieldId}-valid `;
        return `${value}${fieldId}-helper`;
    };
    const extendedFieldProps = {
        ...state.fieldProps,
        name: props.name,
        isDisabled: isDisabled,
        isInvalid: Boolean(state.error),
        isRequired: Boolean(props.isRequired),
        'aria-invalid': state.error ? 'true' : 'false',
        'aria-describedby': getDescribedBy(),
        'aria-labelledby': `${fieldId}-label`,
        id: fieldId
    };
    return /*#__PURE__*/ (0, $2OMIu.jsxs)("div", {
        "data-testid": props.testId,
        className: (0, $bwpsq.default)([
            "_1pfhu2gc"
        ]),
        children: [
            props.label && /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $4utXj.Label), {
                htmlFor: fieldId,
                id: `${fieldId}-label`,
                testId: props.testId && `${props.testId}--label`,
                children: [
                    props.label,
                    props.isRequired && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $8TOd3.default), {}),
                    props.elementAfterLabel
                ]
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $gEL5P.FieldId).Provider, {
                value: fieldId,
                children: props.children({
                    fieldProps: extendedFieldProps,
                    error: state.error,
                    valid: state.valid,
                    meta: state.meta
                })
            })
        ]
    });
}

});
parcelRegister("gEL5P", function(module, exports) {

$parcel$export(module.exports, "FieldId", () => $5e0c7c51c53adaa1$export$3c4232819458a302);

var $5uXOq = parcelRequire("5uXOq");
const $5e0c7c51c53adaa1$export$3c4232819458a302 = /*#__PURE__*/ (0, $5uXOq.createContext)(undefined);

});

parcelRegister("4tW0z", function(module, exports) {

$parcel$export(module.exports, "FormContext", () => $a47152b0a748d3b4$export$c24727297075ec6a);
$parcel$export(module.exports, "IsDisabledContext", () => $a47152b0a748d3b4$export$c17cf6b332a82dbc);
$parcel$export(module.exports, "default", () => $a47152b0a748d3b4$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $lqWDn = parcelRequire("lqWDn");

var $8tHJX = parcelRequire("8tHJX");

var $gZL7V = parcelRequire("gZL7V");
const $a47152b0a748d3b4$export$c24727297075ec6a = /*#__PURE__*/ (0, $5uXOq.createContext)({
    registerField: function() {
        return ()=>{};
    },
    getCurrentValue: ()=>undefined,
    subscribe: function() {
        return ()=>{};
    }
});
const $a47152b0a748d3b4$export$c17cf6b332a82dbc = /*#__PURE__*/ (0, $5uXOq.createContext)(false);
function $a47152b0a748d3b4$export$2e2bcd8739ae039(props) {
    const formRef = (0, $5uXOq.useRef)(null);
    const onSubmitRef = (0, $5uXOq.useRef)(props.onSubmit);
    onSubmitRef.current = props.onSubmit;
    const [form] = (0, $5uXOq.useState)(()=>{
        // Types here would break the existing API
        const finalForm = (0, $lqWDn.createForm)({
            onSubmit: (...args)=>onSubmitRef.current(...args),
            destroyOnUnregister: true,
            initialValues: {},
            mutators: {
                setDefaultValue: ([name, defaultValue], state)=>{
                    if (state.formState.initialValues) {
                        const initialValues = state.formState.initialValues;
                        const values = state.formState.values;
                        const value = name && typeof defaultValue === 'function' ? defaultValue(initialValues[name]) : defaultValue;
                        /* eslint-disable no-param-reassign */ (0, (/*@__PURE__*/$parcel$interopDefault($gZL7V)))(initialValues, name, value);
                        (0, (/*@__PURE__*/$parcel$interopDefault($gZL7V)))(values, name, value);
                    /* eslint-enable */ }
                }
            }
        });
        (0, $8tHJX.default)(()=>formRef.current ? Array.from(formRef.current.querySelectorAll('input')) : [])(finalForm);
        return finalForm;
    });
    const [state, setState] = (0, $5uXOq.useState)({
        dirty: false,
        submitting: false
    });
    (0, $5uXOq.useEffect)(()=>{
        const unsubscribe = form.subscribe(({ dirty: dirty, submitting: submitting })=>{
            setState({
                dirty: dirty,
                submitting: submitting
            });
        }, {
            dirty: true,
            submitting: true
        });
        return unsubscribe;
    }, [
        form
    ]);
    const registerField = (0, $5uXOq.useCallback)((name, defaultValue, subscriber, subscription, config)=>{
        form.pauseValidation();
        const unsubscribe = form.registerField(name, subscriber, subscription, config);
        form.mutators.setDefaultValue(name, defaultValue);
        form.resumeValidation();
        return unsubscribe;
    }, [
        form
    ]);
    const handleSubmit = (e)=>{
        if (e) e.preventDefault();
        form.submit();
    };
    const handleReset = (initialValues)=>{
        form.reset(initialValues);
    };
    const handleKeyDown = (e)=>{
        if (e.key === 'Enter' && (e.ctrlKey || e.metaKey) && formRef.current) {
            const submitButton = formRef.current.querySelector('button:not([type]), button[type="submit"], input[type="submit"]');
            if (submitButton) submitButton.click();
            e.preventDefault();
        }
    };
    const { isDisabled: isDisabled = false, children: children } = props;
    const { dirty: dirty, submitting: submitting } = state;
    /**
	 * This method is needed in FormContext to use it on the field level
	 * to check the current value of the field in case of the component re-mounting.
	 */ const getCurrentValue = (0, $5uXOq.useCallback)((name)=>{
        const formState = form.getState();
        return formState?.values[name] || undefined;
    }, [
        form
    ]);
    const FormContextValue = (0, $5uXOq.useMemo)(()=>{
        return {
            registerField: registerField,
            getCurrentValue: getCurrentValue,
            subscribe: form.subscribe
        };
    }, [
        registerField,
        getCurrentValue,
        form.subscribe
    ]);
    const childrenContent = (()=>{
        if (typeof children === 'function') {
            const result = children.length > 0 ? children({
                formProps: {
                    onSubmit: handleSubmit,
                    ref: formRef,
                    onKeyDown: handleKeyDown
                },
                dirty: dirty,
                reset: handleReset,
                submitting: submitting,
                disabled: isDisabled,
                getState: ()=>form.getState(),
                getValues: ()=>form.getState().values,
                setFieldValue: form.change
            }) : children();
            return result === undefined ? null : result;
        }
        return children;
    })();
    return /*#__PURE__*/ (0, $2OMIu.jsx)($a47152b0a748d3b4$export$c24727297075ec6a.Provider, {
        value: FormContextValue,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)($a47152b0a748d3b4$export$c17cf6b332a82dbc.Provider, {
            value: isDisabled,
            children: childrenContent
        })
    });
}

});
parcelRegister("lqWDn", function(module, exports) {

$parcel$export(module.exports, "getIn", () => $f9a9822f8af64e2a$export$c52e5867d5879e24);
$parcel$export(module.exports, "FORM_ERROR", () => $f9a9822f8af64e2a$export$97cd7fc25dd32915);
$parcel$export(module.exports, "ARRAY_ERROR", () => $f9a9822f8af64e2a$export$735bebc8ffabf28a);
$parcel$export(module.exports, "fieldSubscriptionItems", () => $f9a9822f8af64e2a$export$41e855cb628c1b55);
$parcel$export(module.exports, "formSubscriptionItems", () => $f9a9822f8af64e2a$export$f1ff97b9d1c7a3c3);
$parcel$export(module.exports, "version", () => $f9a9822f8af64e2a$export$83d89fbfd8236492);
$parcel$export(module.exports, "createForm", () => $f9a9822f8af64e2a$export$f681a8129d2e9d28);

var $bS32t = parcelRequire("bS32t");

var $ddEsc = parcelRequire("ddEsc");
//      
var $f9a9822f8af64e2a$var$charCodeOfDot = ".".charCodeAt(0);
var $f9a9822f8af64e2a$var$reEscapeChar = /\\(\\)?/g;
var $f9a9822f8af64e2a$var$rePropName = RegExp(// Match anything that isn't a dot or bracket.
"[^.[\\]]+|\\[(?:([^\"'][^[]*)|([\"'])((?:(?!\\2)[^\\\\]|\\\\.)*?)\\2)\\]|(?=(?:\\.|\\[\\])(?:\\.|\\[\\]|$))", "g");
/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */ var $f9a9822f8af64e2a$var$stringToPath = function stringToPath(string) {
    var result = [];
    if (string.charCodeAt(0) === $f9a9822f8af64e2a$var$charCodeOfDot) result.push("");
    string.replace($f9a9822f8af64e2a$var$rePropName, function(match, expression, quote, subString) {
        var key = match;
        if (quote) key = subString.replace($f9a9822f8af64e2a$var$reEscapeChar, "$1");
        else if (expression) key = expression.trim();
        result.push(key);
    });
    return result;
};
var $f9a9822f8af64e2a$var$keysCache = {};
var $f9a9822f8af64e2a$var$keysRegex = /[.[\]]+/;
var $f9a9822f8af64e2a$var$toPath = function toPath(key) {
    if (key === null || key === undefined || !key.length) return [];
    if (typeof key !== "string") throw new Error("toPath() expects a string");
    if ($f9a9822f8af64e2a$var$keysCache[key] == null) {
        /**
     * The following patch fixes issue 456, introduced since v4.20.3:
     *
     * Before v4.20.3, i.e. in v4.20.2, a `key` like 'choices[]' would map to ['choices']
     * (e.g. an array of choices used where 'choices[]' is name attribute of an input of type checkbox).
     *
     * Since v4.20.3, a `key` like 'choices[]' would map to ['choices', ''] which is wrong and breaks
     * this kind of inputs e.g. in React.
     *
     * v4.20.3 introduced an unwanted breaking change, this patch fixes it, see the issue at the link below.
     *
     * @see https://github.com/final-form/final-form/issues/456
     */ if (key.endsWith("[]")) // v4.20.2 (a `key` like 'choices[]' should map to ['choices'], which is fine).
        $f9a9822f8af64e2a$var$keysCache[key] = key.split($f9a9822f8af64e2a$var$keysRegex).filter(Boolean);
        else // v4.20.3 (a `key` like 'choices[]' maps to ['choices', ''], which breaks applications relying on inputs like `<input type="checkbox" name="choices[]" />`).
        $f9a9822f8af64e2a$var$keysCache[key] = $f9a9822f8af64e2a$var$stringToPath(key);
    }
    return $f9a9822f8af64e2a$var$keysCache[key];
};
//      
var $f9a9822f8af64e2a$export$c52e5867d5879e24 = function getIn(state, complexKey) {
    // Intentionally using iteration rather than recursion
    var path = $f9a9822f8af64e2a$var$toPath(complexKey);
    var current = state;
    for(var i = 0; i < path.length; i++){
        var key = path[i];
        if (current === undefined || current === null || typeof current !== "object" || Array.isArray(current) && isNaN(key)) return undefined;
        current = current[key];
    }
    return current;
};
function $f9a9822f8af64e2a$var$_toPropertyKey(arg) {
    var key = $f9a9822f8af64e2a$var$_toPrimitive(arg, "string");
    return typeof key === "symbol" ? key : String(key);
}
function $f9a9822f8af64e2a$var$_toPrimitive(input, hint) {
    if (typeof input !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (typeof res !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
var $f9a9822f8af64e2a$var$setInRecursor = function setInRecursor(current, index, path, value1, destroyArrays) {
    if (index >= path.length) // end of recursion
    return value1;
    var key = path[index];
    // determine type of key
    if (isNaN(key)) {
        var _extends2;
        // object set
        if (current === undefined || current === null) {
            var _ref;
            // recurse
            var _result = setInRecursor(undefined, index + 1, path, value1, destroyArrays);
            // delete or create an object
            return _result === undefined ? undefined : (_ref = {}, _ref[key] = _result, _ref);
        }
        if (Array.isArray(current)) throw new Error("Cannot set a non-numeric property on an array");
        // current exists, so make a copy of all its values, and add/update the new one
        var _result2 = setInRecursor(current[key], index + 1, path, value1, destroyArrays);
        if (_result2 === undefined) {
            var numKeys = Object.keys(current).length;
            if (current[key] === undefined && numKeys === 0) // object was already empty
            return undefined;
            if (current[key] !== undefined && numKeys <= 1) {
                // only key we had was the one we are deleting
                if (!isNaN(path[index - 1]) && !destroyArrays) // we are in an array, so return an empty object
                return {};
                else return undefined;
            }
            current[key];
            var _final = (0, $ddEsc.default)(current, [
                key
            ].map($f9a9822f8af64e2a$var$_toPropertyKey));
            return _final;
        }
        // set result in key
        return (0, $bS32t.default)({}, current, (_extends2 = {}, _extends2[key] = _result2, _extends2));
    }
    // array set
    var numericKey = Number(key);
    if (current === undefined || current === null) {
        // recurse
        var _result3 = setInRecursor(undefined, index + 1, path, value1, destroyArrays);
        // if nothing returned, delete it
        if (_result3 === undefined) return undefined;
        // create an array
        var _array = [];
        _array[numericKey] = _result3;
        return _array;
    }
    if (!Array.isArray(current)) throw new Error("Cannot set a numeric property on an object");
    // recurse
    var existingValue = current[numericKey];
    var result = setInRecursor(existingValue, index + 1, path, value1, destroyArrays);
    // current exists, so make a copy of all its values, and add/update the new one
    var array = [].concat(current);
    if (destroyArrays && result === undefined) {
        array.splice(numericKey, 1);
        if (array.length === 0) return undefined;
    } else array[numericKey] = result;
    return array;
};
var $f9a9822f8af64e2a$export$e6bdf135a54e021b = function setIn(state, key, value1, destroyArrays) {
    if (destroyArrays === void 0) destroyArrays = false;
    if (state === undefined || state === null) throw new Error("Cannot call setIn() with " + String(state) + " state");
    if (key === undefined || key === null) throw new Error("Cannot call setIn() with " + String(key) + " key");
    // Recursive function needs to accept and return State, but public API should
    // only deal with Objects
    return $f9a9822f8af64e2a$var$setInRecursor(state, 0, $f9a9822f8af64e2a$var$toPath(key), value1, destroyArrays);
};
var $f9a9822f8af64e2a$export$97cd7fc25dd32915 = "FINAL_FORM/form-error";
var $f9a9822f8af64e2a$export$735bebc8ffabf28a = "FINAL_FORM/array-error";
//      
/**
 * Converts internal field state to published field state
 */ function $f9a9822f8af64e2a$var$publishFieldState(formState, field) {
    var errors = formState.errors, initialValues = formState.initialValues, lastSubmittedValues = formState.lastSubmittedValues, submitErrors = formState.submitErrors, submitFailed = formState.submitFailed, submitSucceeded = formState.submitSucceeded, submitting = formState.submitting, values = formState.values;
    var active = field.active, blur = field.blur, change = field.change, data = field.data, focus = field.focus, modified = field.modified, modifiedSinceLastSubmit = field.modifiedSinceLastSubmit, name = field.name, touched = field.touched, validating = field.validating, visited = field.visited;
    var value1 = $f9a9822f8af64e2a$export$c52e5867d5879e24(values, name);
    var error = $f9a9822f8af64e2a$export$c52e5867d5879e24(errors, name);
    if (error && error[$f9a9822f8af64e2a$export$735bebc8ffabf28a]) error = error[$f9a9822f8af64e2a$export$735bebc8ffabf28a];
    var submitError = submitErrors && $f9a9822f8af64e2a$export$c52e5867d5879e24(submitErrors, name);
    var initial = initialValues && $f9a9822f8af64e2a$export$c52e5867d5879e24(initialValues, name);
    var pristine = field.isEqual(initial, value1);
    var dirtySinceLastSubmit = !!(lastSubmittedValues && !field.isEqual($f9a9822f8af64e2a$export$c52e5867d5879e24(lastSubmittedValues, name), value1));
    var valid = !error && !submitError;
    return {
        active: active,
        blur: blur,
        change: change,
        data: data,
        dirty: !pristine,
        dirtySinceLastSubmit: dirtySinceLastSubmit,
        error: error,
        focus: focus,
        initial: initial,
        invalid: !valid,
        length: Array.isArray(value1) ? value1.length : undefined,
        modified: modified,
        modifiedSinceLastSubmit: modifiedSinceLastSubmit,
        name: name,
        pristine: pristine,
        submitError: submitError,
        submitFailed: submitFailed,
        submitSucceeded: submitSucceeded,
        submitting: submitting,
        touched: touched,
        valid: valid,
        value: value1,
        visited: visited,
        validating: validating
    };
}
//      
var $f9a9822f8af64e2a$export$41e855cb628c1b55 = [
    "active",
    "data",
    "dirty",
    "dirtySinceLastSubmit",
    "error",
    "initial",
    "invalid",
    "length",
    "modified",
    "modifiedSinceLastSubmit",
    "pristine",
    "submitError",
    "submitFailed",
    "submitSucceeded",
    "submitting",
    "touched",
    "valid",
    "value",
    "visited",
    "validating"
];
//      
var $f9a9822f8af64e2a$var$shallowEqual = function shallowEqual(a, b) {
    if (a === b) return true;
    if (typeof a !== "object" || !a || typeof b !== "object" || !b) return false;
    var keysA = Object.keys(a);
    var keysB = Object.keys(b);
    if (keysA.length !== keysB.length) return false;
    var bHasOwnProperty = Object.prototype.hasOwnProperty.bind(b);
    for(var idx = 0; idx < keysA.length; idx++){
        var key = keysA[idx];
        if (!bHasOwnProperty(key) || a[key] !== b[key]) return false;
    }
    return true;
};
//      
function $f9a9822f8af64e2a$var$subscriptionFilter(dest, src, previous, subscription, keys, shallowEqualKeys) {
    var different = false;
    keys.forEach(function(key) {
        if (subscription[key]) {
            dest[key] = src[key];
            if (!previous || (~shallowEqualKeys.indexOf(key) ? !$f9a9822f8af64e2a$var$shallowEqual(src[key], previous[key]) : src[key] !== previous[key])) different = true;
        }
    });
    return different;
}
//      
var $f9a9822f8af64e2a$var$shallowEqualKeys$1 = [
    "data"
];
/**
 * Filters items in a FieldState based on a FieldSubscription
 */ var $f9a9822f8af64e2a$var$filterFieldState = function filterFieldState(state, previousState, subscription, force) {
    var result = {
        blur: state.blur,
        change: state.change,
        focus: state.focus,
        name: state.name
    };
    var different = $f9a9822f8af64e2a$var$subscriptionFilter(result, state, previousState, subscription, $f9a9822f8af64e2a$export$41e855cb628c1b55, $f9a9822f8af64e2a$var$shallowEqualKeys$1) || !previousState;
    return different || force ? result : undefined;
};
//      
var $f9a9822f8af64e2a$export$f1ff97b9d1c7a3c3 = [
    "active",
    "dirty",
    "dirtyFields",
    "dirtyFieldsSinceLastSubmit",
    "dirtySinceLastSubmit",
    "error",
    "errors",
    "hasSubmitErrors",
    "hasValidationErrors",
    "initialValues",
    "invalid",
    "modified",
    "modifiedSinceLastSubmit",
    "pristine",
    "submitting",
    "submitError",
    "submitErrors",
    "submitFailed",
    "submitSucceeded",
    "touched",
    "valid",
    "validating",
    "values",
    "visited"
];
//      
var $f9a9822f8af64e2a$var$shallowEqualKeys = [
    "touched",
    "visited"
];
/**
 * Filters items in a FormState based on a FormSubscription
 */ function $f9a9822f8af64e2a$var$filterFormState(state, previousState, subscription, force) {
    var result = {};
    var different = $f9a9822f8af64e2a$var$subscriptionFilter(result, state, previousState, subscription, $f9a9822f8af64e2a$export$f1ff97b9d1c7a3c3, $f9a9822f8af64e2a$var$shallowEqualKeys) || !previousState;
    return different || force ? result : undefined;
}
//      
var $f9a9822f8af64e2a$var$memoize = function memoize(fn) {
    var lastArgs;
    var lastResult;
    return function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        if (!lastArgs || args.length !== lastArgs.length || args.some(function(arg, index) {
            return !$f9a9822f8af64e2a$var$shallowEqual(lastArgs[index], arg);
        })) {
            lastArgs = args;
            lastResult = fn.apply(void 0, args);
        }
        return lastResult;
    };
};
var $f9a9822f8af64e2a$var$isPromise = function(obj) {
    return !!obj && (typeof obj === "object" || typeof obj === "function") && typeof obj.then === "function";
};
var $f9a9822f8af64e2a$export$83d89fbfd8236492 = "4.20.10";
var $f9a9822f8af64e2a$export$480bc304a47a3b09 = [
    "debug",
    "initialValues",
    "keepDirtyOnReinitialize",
    "mutators",
    "onSubmit",
    "validate",
    "validateOnBlur"
];
var $f9a9822f8af64e2a$var$tripleEquals = function tripleEquals(a, b) {
    return a === b;
};
var $f9a9822f8af64e2a$var$hasAnyError = function hasAnyError(errors) {
    return Object.keys(errors).some(function(key) {
        var value1 = errors[key];
        if (value1 && typeof value1 === "object" && !(value1 instanceof Error)) return hasAnyError(value1);
        return typeof value1 !== "undefined";
    });
};
function $f9a9822f8af64e2a$var$convertToExternalFormState(_ref) {
    var active = _ref.active, dirtySinceLastSubmit = _ref.dirtySinceLastSubmit, modifiedSinceLastSubmit = _ref.modifiedSinceLastSubmit, error = _ref.error, errors = _ref.errors, initialValues = _ref.initialValues, pristine = _ref.pristine, submitting = _ref.submitting, submitFailed = _ref.submitFailed, submitSucceeded = _ref.submitSucceeded, submitError = _ref.submitError, submitErrors = _ref.submitErrors, valid = _ref.valid, validating = _ref.validating, values = _ref.values;
    return {
        active: active,
        dirty: !pristine,
        dirtySinceLastSubmit: dirtySinceLastSubmit,
        modifiedSinceLastSubmit: modifiedSinceLastSubmit,
        error: error,
        errors: errors,
        hasSubmitErrors: !!(submitError || submitErrors && $f9a9822f8af64e2a$var$hasAnyError(submitErrors)),
        hasValidationErrors: !!(error || $f9a9822f8af64e2a$var$hasAnyError(errors)),
        invalid: !valid,
        initialValues: initialValues,
        pristine: pristine,
        submitting: submitting,
        submitFailed: submitFailed,
        submitSucceeded: submitSucceeded,
        submitError: submitError,
        submitErrors: submitErrors,
        valid: valid,
        validating: validating > 0,
        values: values
    };
}
function $f9a9822f8af64e2a$var$notifySubscriber(subscriber, subscription, state, lastState, filter, force) {
    var notification = filter(state, lastState, subscription, force);
    if (notification) {
        subscriber(notification);
        return true;
    }
    return false;
}
function $f9a9822f8af64e2a$var$notify(_ref2, state, lastState, filter, force) {
    var entries = _ref2.entries;
    Object.keys(entries).forEach(function(key) {
        var entry = entries[Number(key)];
        // istanbul ignore next
        if (entry) {
            var subscription = entry.subscription, subscriber = entry.subscriber, notified = entry.notified;
            if ($f9a9822f8af64e2a$var$notifySubscriber(subscriber, subscription, state, lastState, filter, force || !notified)) entry.notified = true;
        }
    });
}
function $f9a9822f8af64e2a$export$f681a8129d2e9d28(config) {
    if (!config) throw new Error("No config specified");
    var debug = config.debug, destroyOnUnregister = config.destroyOnUnregister, keepDirtyOnReinitialize = config.keepDirtyOnReinitialize, initialValues = config.initialValues, mutators = config.mutators, onSubmit = config.onSubmit, validate = config.validate, validateOnBlur = config.validateOnBlur;
    if (!onSubmit) throw new Error("No onSubmit function specified");
    var state = {
        subscribers: {
            index: 0,
            entries: {}
        },
        fieldSubscribers: {},
        fields: {},
        formState: {
            asyncErrors: {},
            dirtySinceLastSubmit: false,
            modifiedSinceLastSubmit: false,
            errors: {},
            initialValues: initialValues && (0, $bS32t.default)({}, initialValues),
            invalid: false,
            pristine: true,
            submitting: false,
            submitFailed: false,
            submitSucceeded: false,
            resetWhileSubmitting: false,
            valid: true,
            validating: 0,
            values: initialValues ? (0, $bS32t.default)({}, initialValues) : {}
        },
        lastFormState: undefined
    };
    var inBatch = 0;
    var validationPaused = false;
    var validationBlocked = false;
    var preventNotificationWhileValidationPaused = false;
    var nextAsyncValidationKey = 0;
    var asyncValidationPromises = {};
    var clearAsyncValidationPromise = function clearAsyncValidationPromise(key) {
        return function(result) {
            delete asyncValidationPromises[key];
            return result;
        };
    };
    var changeValue = function changeValue(state, name, mutate) {
        var before = $f9a9822f8af64e2a$export$c52e5867d5879e24(state.formState.values, name);
        var after = mutate(before);
        state.formState.values = $f9a9822f8af64e2a$export$e6bdf135a54e021b(state.formState.values, name, after) || {};
    };
    var renameField = function renameField(state, from, to) {
        if (state.fields[from]) {
            var _extends2, _extends3;
            state.fields = (0, $bS32t.default)({}, state.fields, (_extends2 = {}, _extends2[to] = (0, $bS32t.default)({}, state.fields[from], {
                name: to,
                // rebind event handlers
                blur: function blur() {
                    return api.blur(to);
                },
                change: function change(value1) {
                    return api.change(to, value1);
                },
                focus: function focus() {
                    return api.focus(to);
                },
                lastFieldState: undefined
            }), _extends2));
            delete state.fields[from];
            state.fieldSubscribers = (0, $bS32t.default)({}, state.fieldSubscribers, (_extends3 = {}, _extends3[to] = state.fieldSubscribers[from], _extends3));
            delete state.fieldSubscribers[from];
            var value1 = $f9a9822f8af64e2a$export$c52e5867d5879e24(state.formState.values, from);
            state.formState.values = $f9a9822f8af64e2a$export$e6bdf135a54e021b(state.formState.values, from, undefined) || {};
            state.formState.values = $f9a9822f8af64e2a$export$e6bdf135a54e021b(state.formState.values, to, value1);
            delete state.lastFormState;
        }
    };
    // bind state to mutators
    var getMutatorApi = function getMutatorApi(key) {
        return function() {
            // istanbul ignore next
            if (mutators) {
                // ^^ causes branch coverage warning, but needed to appease the Flow gods
                var mutatableState = {
                    formState: state.formState,
                    fields: state.fields,
                    fieldSubscribers: state.fieldSubscribers,
                    lastFormState: state.lastFormState
                };
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
                var returnValue = mutators[key](args, mutatableState, {
                    changeValue: changeValue,
                    getIn: $f9a9822f8af64e2a$export$c52e5867d5879e24,
                    renameField: renameField,
                    resetFieldState: api.resetFieldState,
                    setIn: $f9a9822f8af64e2a$export$e6bdf135a54e021b,
                    shallowEqual: $f9a9822f8af64e2a$var$shallowEqual
                });
                state.formState = mutatableState.formState;
                state.fields = mutatableState.fields;
                state.fieldSubscribers = mutatableState.fieldSubscribers;
                state.lastFormState = mutatableState.lastFormState;
                runValidation(undefined, function() {
                    notifyFieldListeners();
                    notifyFormListeners();
                });
                return returnValue;
            }
        };
    };
    var mutatorsApi = mutators ? Object.keys(mutators).reduce(function(result, key) {
        result[key] = getMutatorApi(key);
        return result;
    }, {}) : {};
    var runRecordLevelValidation = function runRecordLevelValidation(setErrors) {
        var promises = [];
        if (validate) {
            var errorsOrPromise = validate((0, $bS32t.default)({}, state.formState.values)); // clone to avoid writing
            if ($f9a9822f8af64e2a$var$isPromise(errorsOrPromise)) promises.push(errorsOrPromise.then(function(errors) {
                return setErrors(errors, true);
            }));
            else setErrors(errorsOrPromise, false);
        }
        return promises;
    };
    var getValidators = function getValidators(field) {
        return Object.keys(field.validators).reduce(function(result, index) {
            var validator = field.validators[Number(index)]();
            if (validator) result.push(validator);
            return result;
        }, []);
    };
    var runFieldLevelValidation = function runFieldLevelValidation(field, setError) {
        var promises = [];
        var validators = getValidators(field);
        if (validators.length) {
            var error;
            validators.forEach(function(validator) {
                var errorOrPromise = validator($f9a9822f8af64e2a$export$c52e5867d5879e24(state.formState.values, field.name), state.formState.values, validator.length === 0 || validator.length === 3 ? $f9a9822f8af64e2a$var$publishFieldState(state.formState, state.fields[field.name]) : undefined);
                if (errorOrPromise && $f9a9822f8af64e2a$var$isPromise(errorOrPromise)) {
                    field.validating = true;
                    var promise = errorOrPromise.then(function(error) {
                        if (state.fields[field.name]) {
                            state.fields[field.name].validating = false;
                            setError(error);
                        }
                    }); // errors must be resolved, not rejected
                    promises.push(promise);
                } else if (!error) // first registered validator wins
                error = errorOrPromise;
            });
            setError(error);
        }
        return promises;
    };
    var runValidation = function runValidation(fieldChanged, callback) {
        if (validationPaused) {
            validationBlocked = true;
            callback();
            return;
        }
        var fields = state.fields, formState = state.formState;
        var safeFields = (0, $bS32t.default)({}, fields);
        var fieldKeys = Object.keys(safeFields);
        if (!validate && !fieldKeys.some(function(key) {
            return getValidators(safeFields[key]).length;
        })) {
            callback();
            return; // no validation rules
        }
        // pare down field keys to actually validate
        var limitedFieldLevelValidation = false;
        if (fieldChanged) {
            var changedField = safeFields[fieldChanged];
            if (changedField) {
                var validateFields = changedField.validateFields;
                if (validateFields) {
                    limitedFieldLevelValidation = true;
                    fieldKeys = validateFields.length ? validateFields.concat(fieldChanged) : [
                        fieldChanged
                    ];
                }
            }
        }
        var recordLevelErrors = {};
        var asyncRecordLevelErrors = {};
        var fieldLevelErrors = {};
        var promises = [].concat(runRecordLevelValidation(function(errors, wasAsync) {
            if (wasAsync) asyncRecordLevelErrors = errors || {};
            else recordLevelErrors = errors || {};
        }), fieldKeys.reduce(function(result, name) {
            return result.concat(runFieldLevelValidation(fields[name], function(error) {
                fieldLevelErrors[name] = error;
            }));
        }, []));
        var hasAsyncValidations = promises.length > 0;
        var asyncValidationPromiseKey = ++nextAsyncValidationKey;
        var promise = Promise.all(promises).then(clearAsyncValidationPromise(asyncValidationPromiseKey));
        // backwards-compat: add promise to submit-blocking promises iff there are any promises to await
        if (hasAsyncValidations) asyncValidationPromises[asyncValidationPromiseKey] = promise;
        var processErrors = function processErrors(afterAsync) {
            var merged = (0, $bS32t.default)({}, limitedFieldLevelValidation ? formState.errors : {}, recordLevelErrors, afterAsync ? asyncRecordLevelErrors // new async errors
             : formState.asyncErrors);
            var forEachError = function forEachError(fn) {
                fieldKeys.forEach(function(name) {
                    if (fields[name]) {
                        // make sure field is still registered
                        // field-level errors take precedent over record-level errors
                        var recordLevelError = $f9a9822f8af64e2a$export$c52e5867d5879e24(recordLevelErrors, name);
                        var errorFromParent = $f9a9822f8af64e2a$export$c52e5867d5879e24(merged, name);
                        var hasFieldLevelValidation = getValidators(safeFields[name]).length;
                        var fieldLevelError = fieldLevelErrors[name];
                        fn(name, hasFieldLevelValidation && fieldLevelError || validate && recordLevelError || (!recordLevelError && !limitedFieldLevelValidation ? errorFromParent : undefined));
                    }
                });
            };
            forEachError(function(name, error) {
                merged = $f9a9822f8af64e2a$export$e6bdf135a54e021b(merged, name, error) || {};
            });
            forEachError(function(name, error) {
                if (error && error[$f9a9822f8af64e2a$export$735bebc8ffabf28a]) {
                    var existing = $f9a9822f8af64e2a$export$c52e5867d5879e24(merged, name);
                    var copy = [].concat(existing);
                    copy[$f9a9822f8af64e2a$export$735bebc8ffabf28a] = error[$f9a9822f8af64e2a$export$735bebc8ffabf28a];
                    merged = $f9a9822f8af64e2a$export$e6bdf135a54e021b(merged, name, copy);
                }
            });
            if (!$f9a9822f8af64e2a$var$shallowEqual(formState.errors, merged)) formState.errors = merged;
            if (afterAsync) formState.asyncErrors = asyncRecordLevelErrors;
            formState.error = recordLevelErrors[$f9a9822f8af64e2a$export$97cd7fc25dd32915];
        };
        if (hasAsyncValidations) {
            // async validations are running, ensure validating is true before notifying
            state.formState.validating++;
            callback();
        }
        // process sync errors
        processErrors(false);
        // sync errors have been set. notify listeners while we wait for others
        callback();
        if (hasAsyncValidations) {
            var afterPromise = function afterPromise() {
                state.formState.validating--;
                callback();
                // field async validation may affect formState validating
                // so force notifyFormListeners if validating is still 0 after callback finished
                // and lastFormState validating is true
                if (state.formState.validating === 0 && state.lastFormState.validating) notifyFormListeners();
            };
            promise.then(function() {
                if (nextAsyncValidationKey > asyncValidationPromiseKey) // if this async validator has been superseded by another, ignore its results
                return;
                processErrors(true);
            }).then(afterPromise, afterPromise);
        }
    };
    var notifyFieldListeners = function notifyFieldListeners(name) {
        if (inBatch) return;
        var fields = state.fields, fieldSubscribers = state.fieldSubscribers, formState = state.formState;
        var safeFields = (0, $bS32t.default)({}, fields);
        var notifyField = function notifyField(name) {
            var field = safeFields[name];
            var fieldState = $f9a9822f8af64e2a$var$publishFieldState(formState, field);
            var lastFieldState = field.lastFieldState;
            field.lastFieldState = fieldState;
            var fieldSubscriber = fieldSubscribers[name];
            if (fieldSubscriber) $f9a9822f8af64e2a$var$notify(fieldSubscriber, fieldState, lastFieldState, $f9a9822f8af64e2a$var$filterFieldState, lastFieldState === undefined);
        };
        if (name) notifyField(name);
        else Object.keys(safeFields).forEach(notifyField);
    };
    var markAllFieldsTouched = function markAllFieldsTouched() {
        Object.keys(state.fields).forEach(function(key) {
            state.fields[key].touched = true;
        });
    };
    var hasSyncErrors = function hasSyncErrors() {
        return !!(state.formState.error || $f9a9822f8af64e2a$var$hasAnyError(state.formState.errors));
    };
    var calculateNextFormState = function calculateNextFormState() {
        var fields = state.fields, formState = state.formState, lastFormState = state.lastFormState;
        var safeFields = (0, $bS32t.default)({}, fields);
        var safeFieldKeys = Object.keys(safeFields);
        // calculate dirty/pristine
        var foundDirty = false;
        var dirtyFields = safeFieldKeys.reduce(function(result, key) {
            var dirty = !safeFields[key].isEqual($f9a9822f8af64e2a$export$c52e5867d5879e24(formState.values, key), $f9a9822f8af64e2a$export$c52e5867d5879e24(formState.initialValues || {}, key));
            if (dirty) {
                foundDirty = true;
                result[key] = true;
            }
            return result;
        }, {});
        var dirtyFieldsSinceLastSubmit = safeFieldKeys.reduce(function(result, key) {
            // istanbul ignore next
            var nonNullLastSubmittedValues = formState.lastSubmittedValues || {}; // || {} is for flow, but causes branch coverage complaint
            if (!safeFields[key].isEqual($f9a9822f8af64e2a$export$c52e5867d5879e24(formState.values, key), $f9a9822f8af64e2a$export$c52e5867d5879e24(nonNullLastSubmittedValues, key))) result[key] = true;
            return result;
        }, {});
        formState.pristine = !foundDirty;
        formState.dirtySinceLastSubmit = !!(formState.lastSubmittedValues && Object.values(dirtyFieldsSinceLastSubmit).some(function(value1) {
            return value1;
        }));
        formState.modifiedSinceLastSubmit = !!(formState.lastSubmittedValues && // Object.values would treat values as mixed (facebook/flow#2221)
        Object.keys(safeFields).some(function(value1) {
            return safeFields[value1].modifiedSinceLastSubmit;
        }));
        formState.valid = !formState.error && !formState.submitError && !$f9a9822f8af64e2a$var$hasAnyError(formState.errors) && !(formState.submitErrors && $f9a9822f8af64e2a$var$hasAnyError(formState.submitErrors));
        var nextFormState = $f9a9822f8af64e2a$var$convertToExternalFormState(formState);
        var _safeFieldKeys$reduce = safeFieldKeys.reduce(function(result, key) {
            result.modified[key] = safeFields[key].modified;
            result.touched[key] = safeFields[key].touched;
            result.visited[key] = safeFields[key].visited;
            return result;
        }, {
            modified: {},
            touched: {},
            visited: {}
        }), modified = _safeFieldKeys$reduce.modified, touched = _safeFieldKeys$reduce.touched, visited = _safeFieldKeys$reduce.visited;
        nextFormState.dirtyFields = lastFormState && $f9a9822f8af64e2a$var$shallowEqual(lastFormState.dirtyFields, dirtyFields) ? lastFormState.dirtyFields : dirtyFields;
        nextFormState.dirtyFieldsSinceLastSubmit = lastFormState && $f9a9822f8af64e2a$var$shallowEqual(lastFormState.dirtyFieldsSinceLastSubmit, dirtyFieldsSinceLastSubmit) ? lastFormState.dirtyFieldsSinceLastSubmit : dirtyFieldsSinceLastSubmit;
        nextFormState.modified = lastFormState && $f9a9822f8af64e2a$var$shallowEqual(lastFormState.modified, modified) ? lastFormState.modified : modified;
        nextFormState.touched = lastFormState && $f9a9822f8af64e2a$var$shallowEqual(lastFormState.touched, touched) ? lastFormState.touched : touched;
        nextFormState.visited = lastFormState && $f9a9822f8af64e2a$var$shallowEqual(lastFormState.visited, visited) ? lastFormState.visited : visited;
        return lastFormState && $f9a9822f8af64e2a$var$shallowEqual(lastFormState, nextFormState) ? lastFormState : nextFormState;
    };
    var callDebug = function callDebug() {
        return debug && true && debug(calculateNextFormState(), Object.keys(state.fields).reduce(function(result, key) {
            result[key] = state.fields[key];
            return result;
        }, {}));
    };
    var notifying = false;
    var scheduleNotification = false;
    var notifyFormListeners = function notifyFormListeners() {
        if (notifying) scheduleNotification = true;
        else {
            notifying = true;
            callDebug();
            if (!inBatch && !(validationPaused && preventNotificationWhileValidationPaused)) {
                var lastFormState = state.lastFormState;
                var nextFormState = calculateNextFormState();
                if (nextFormState !== lastFormState) {
                    state.lastFormState = nextFormState;
                    $f9a9822f8af64e2a$var$notify(state.subscribers, nextFormState, lastFormState, $f9a9822f8af64e2a$var$filterFormState);
                }
            }
            notifying = false;
            if (scheduleNotification) {
                scheduleNotification = false;
                notifyFormListeners();
            }
        }
    };
    var beforeSubmit = function beforeSubmit() {
        return Object.keys(state.fields).some(function(name) {
            return state.fields[name].beforeSubmit && state.fields[name].beforeSubmit() === false;
        });
    };
    var afterSubmit = function afterSubmit() {
        return Object.keys(state.fields).forEach(function(name) {
            return state.fields[name].afterSubmit && state.fields[name].afterSubmit();
        });
    };
    var resetModifiedAfterSubmit = function resetModifiedAfterSubmit() {
        return Object.keys(state.fields).forEach(function(key) {
            return state.fields[key].modifiedSinceLastSubmit = false;
        });
    };
    // generate initial errors
    runValidation(undefined, function() {
        notifyFormListeners();
    });
    var api = {
        batch: function batch(fn) {
            inBatch++;
            fn();
            inBatch--;
            notifyFieldListeners();
            notifyFormListeners();
        },
        blur: function blur(name) {
            var fields = state.fields, formState = state.formState;
            var previous = fields[name];
            if (previous) {
                // can only blur registered fields
                delete formState.active;
                fields[name] = (0, $bS32t.default)({}, previous, {
                    active: false,
                    touched: true
                });
                if (validateOnBlur) runValidation(name, function() {
                    notifyFieldListeners();
                    notifyFormListeners();
                });
                else {
                    notifyFieldListeners();
                    notifyFormListeners();
                }
            }
        },
        change: function change(name, value1) {
            var fields = state.fields, formState = state.formState;
            if ($f9a9822f8af64e2a$export$c52e5867d5879e24(formState.values, name) !== value1) {
                changeValue(state, name, function() {
                    return value1;
                });
                var previous = fields[name];
                if (previous) // only track modified for registered fields
                fields[name] = (0, $bS32t.default)({}, previous, {
                    modified: true,
                    modifiedSinceLastSubmit: !!formState.lastSubmittedValues
                });
                if (validateOnBlur) {
                    notifyFieldListeners();
                    notifyFormListeners();
                } else runValidation(name, function() {
                    notifyFieldListeners();
                    notifyFormListeners();
                });
            }
        },
        get destroyOnUnregister () {
            return !!destroyOnUnregister;
        },
        set destroyOnUnregister (value){
            destroyOnUnregister = value;
        },
        focus: function focus(name) {
            var field = state.fields[name];
            if (field && !field.active) {
                state.formState.active = name;
                field.active = true;
                field.visited = true;
                notifyFieldListeners();
                notifyFormListeners();
            }
        },
        mutators: mutatorsApi,
        getFieldState: function getFieldState(name) {
            var field = state.fields[name];
            return field && field.lastFieldState;
        },
        getRegisteredFields: function getRegisteredFields() {
            return Object.keys(state.fields);
        },
        getState: function getState() {
            return calculateNextFormState();
        },
        initialize: function initialize(data) {
            var fields = state.fields, formState = state.formState;
            var safeFields = (0, $bS32t.default)({}, fields);
            var values = typeof data === "function" ? data(formState.values) : data;
            if (!keepDirtyOnReinitialize) formState.values = values;
            /**
       * Hello, inquisitive code reader! Thanks for taking the time to dig in!
       *
       * The following code is the way it is to allow for non-registered deep
       * field values to be set via initialize()
       */ // save dirty values
            var savedDirtyValues = keepDirtyOnReinitialize ? Object.keys(safeFields).reduce(function(result, key) {
                var field = safeFields[key];
                var pristine = field.isEqual($f9a9822f8af64e2a$export$c52e5867d5879e24(formState.values, key), $f9a9822f8af64e2a$export$c52e5867d5879e24(formState.initialValues || {}, key));
                if (!pristine) result[key] = $f9a9822f8af64e2a$export$c52e5867d5879e24(formState.values, key);
                return result;
            }, {}) : {};
            // update initalValues and values
            formState.initialValues = values;
            formState.values = values;
            // restore the dirty values
            Object.keys(savedDirtyValues).forEach(function(key) {
                formState.values = $f9a9822f8af64e2a$export$e6bdf135a54e021b(formState.values, key, savedDirtyValues[key]) || {};
            });
            runValidation(undefined, function() {
                notifyFieldListeners();
                notifyFormListeners();
            });
        },
        isValidationPaused: function isValidationPaused() {
            return validationPaused;
        },
        pauseValidation: function pauseValidation(preventNotification) {
            if (preventNotification === void 0) preventNotification = true;
            validationPaused = true;
            preventNotificationWhileValidationPaused = preventNotification;
        },
        registerField: function registerField(name, subscriber, subscription, fieldConfig) {
            if (subscription === void 0) subscription = {};
            if (!state.fieldSubscribers[name]) state.fieldSubscribers[name] = {
                index: 0,
                entries: {}
            };
            var index = state.fieldSubscribers[name].index++;
            // save field subscriber callback
            state.fieldSubscribers[name].entries[index] = {
                subscriber: $f9a9822f8af64e2a$var$memoize(subscriber),
                subscription: subscription,
                notified: false
            };
            // create initial field state if not exists
            var field = state.fields[name] || {
                active: false,
                afterSubmit: fieldConfig && fieldConfig.afterSubmit,
                beforeSubmit: fieldConfig && fieldConfig.beforeSubmit,
                data: fieldConfig && fieldConfig.data || {},
                isEqual: fieldConfig && fieldConfig.isEqual || $f9a9822f8af64e2a$var$tripleEquals,
                lastFieldState: undefined,
                modified: false,
                modifiedSinceLastSubmit: false,
                name: name,
                touched: false,
                valid: true,
                validateFields: fieldConfig && fieldConfig.validateFields,
                validators: {},
                validating: false,
                visited: false
            };
            // Mutators can create a field in order to keep the field states
            // We must update this field when registerField is called afterwards
            field.blur = field.blur || function() {
                return api.blur(name);
            };
            field.change = field.change || function(value1) {
                return api.change(name, value1);
            };
            field.focus = field.focus || function() {
                return api.focus(name);
            };
            state.fields[name] = field;
            var haveValidator = false;
            var silent = fieldConfig && fieldConfig.silent;
            var notify = function notify() {
                if (silent && state.fields[name]) notifyFieldListeners(name);
                else {
                    notifyFormListeners();
                    notifyFieldListeners();
                }
            };
            if (fieldConfig) {
                haveValidator = !!(fieldConfig.getValidator && fieldConfig.getValidator());
                if (fieldConfig.getValidator) state.fields[name].validators[index] = fieldConfig.getValidator;
                var noValueInFormState = $f9a9822f8af64e2a$export$c52e5867d5879e24(state.formState.values, name) === undefined;
                if (fieldConfig.initialValue !== undefined && (noValueInFormState || $f9a9822f8af64e2a$export$c52e5867d5879e24(state.formState.values, name) === $f9a9822f8af64e2a$export$c52e5867d5879e24(state.formState.initialValues, name))) {
                    state.formState.initialValues = $f9a9822f8af64e2a$export$e6bdf135a54e021b(state.formState.initialValues || {}, name, fieldConfig.initialValue);
                    state.formState.values = $f9a9822f8af64e2a$export$e6bdf135a54e021b(state.formState.values, name, fieldConfig.initialValue);
                    runValidation(undefined, notify);
                }
                // only use defaultValue if we don't yet have any value for this field
                if (fieldConfig.defaultValue !== undefined && fieldConfig.initialValue === undefined && $f9a9822f8af64e2a$export$c52e5867d5879e24(state.formState.initialValues, name) === undefined && noValueInFormState) state.formState.values = $f9a9822f8af64e2a$export$e6bdf135a54e021b(state.formState.values, name, fieldConfig.defaultValue);
            }
            if (haveValidator) runValidation(undefined, notify);
            else notify();
            return function() {
                var validatorRemoved = false;
                // istanbul ignore next
                if (state.fields[name]) {
                    // state.fields[name] may have been removed by a mutator
                    validatorRemoved = !!(state.fields[name].validators[index] && state.fields[name].validators[index]());
                    delete state.fields[name].validators[index];
                }
                var hasFieldSubscribers = !!state.fieldSubscribers[name];
                if (hasFieldSubscribers) // state.fieldSubscribers[name] may have been removed by a mutator
                delete state.fieldSubscribers[name].entries[index];
                var lastOne = hasFieldSubscribers && !Object.keys(state.fieldSubscribers[name].entries).length;
                if (lastOne) {
                    delete state.fieldSubscribers[name];
                    delete state.fields[name];
                    if (validatorRemoved) state.formState.errors = $f9a9822f8af64e2a$export$e6bdf135a54e021b(state.formState.errors, name, undefined) || {};
                    if (destroyOnUnregister) state.formState.values = $f9a9822f8af64e2a$export$e6bdf135a54e021b(state.formState.values, name, undefined, true) || {};
                }
                if (!silent) {
                    if (validatorRemoved) runValidation(undefined, function() {
                        notifyFormListeners();
                        notifyFieldListeners();
                    });
                    else if (lastOne) // values or errors may have changed
                    notifyFormListeners();
                }
            };
        },
        reset: function reset(initialValues) {
            if (initialValues === void 0) initialValues = state.formState.initialValues;
            if (state.formState.submitting) state.formState.resetWhileSubmitting = true;
            state.formState.submitFailed = false;
            state.formState.submitSucceeded = false;
            delete state.formState.submitError;
            delete state.formState.submitErrors;
            delete state.formState.lastSubmittedValues;
            api.initialize(initialValues || {});
        },
        /**
     * Resets all field flags (e.g. touched, visited, etc.) to their initial state
     */ resetFieldState: function resetFieldState(name) {
            state.fields[name] = (0, $bS32t.default)({}, state.fields[name], {
                active: false,
                lastFieldState: undefined,
                modified: false,
                touched: false,
                valid: true,
                validating: false,
                visited: false
            });
            runValidation(undefined, function() {
                notifyFieldListeners();
                notifyFormListeners();
            });
        },
        /**
     * Returns the form to a clean slate; that is:
     * - Clear all values
     * - Resets all fields to their initial state
     */ restart: function restart(initialValues) {
            if (initialValues === void 0) initialValues = state.formState.initialValues;
            api.batch(function() {
                for(var name in state.fields){
                    api.resetFieldState(name);
                    state.fields[name] = (0, $bS32t.default)({}, state.fields[name], {
                        active: false,
                        lastFieldState: undefined,
                        modified: false,
                        modifiedSinceLastSubmit: false,
                        touched: false,
                        valid: true,
                        validating: false,
                        visited: false
                    });
                }
                api.reset(initialValues);
            });
        },
        resumeValidation: function resumeValidation() {
            validationPaused = false;
            preventNotificationWhileValidationPaused = false;
            if (validationBlocked) // validation was attempted while it was paused, so run it now
            runValidation(undefined, function() {
                notifyFieldListeners();
                notifyFormListeners();
            });
            validationBlocked = false;
        },
        setConfig: function setConfig(name, value1) {
            switch(name){
                case "debug":
                    debug = value1;
                    break;
                case "destroyOnUnregister":
                    destroyOnUnregister = value1;
                    break;
                case "initialValues":
                    api.initialize(value1);
                    break;
                case "keepDirtyOnReinitialize":
                    keepDirtyOnReinitialize = value1;
                    break;
                case "mutators":
                    mutators = value1;
                    if (value1) {
                        Object.keys(mutatorsApi).forEach(function(key) {
                            if (!(key in value1)) delete mutatorsApi[key];
                        });
                        Object.keys(value1).forEach(function(key) {
                            mutatorsApi[key] = getMutatorApi(key);
                        });
                    } else Object.keys(mutatorsApi).forEach(function(key) {
                        delete mutatorsApi[key];
                    });
                    break;
                case "onSubmit":
                    onSubmit = value1;
                    break;
                case "validate":
                    validate = value1;
                    runValidation(undefined, function() {
                        notifyFieldListeners();
                        notifyFormListeners();
                    });
                    break;
                case "validateOnBlur":
                    validateOnBlur = value1;
                    break;
                default:
                    throw new Error("Unrecognised option " + name);
            }
        },
        submit: function submit() {
            var formState = state.formState;
            if (formState.submitting) return;
            delete formState.submitErrors;
            delete formState.submitError;
            formState.lastSubmittedValues = (0, $bS32t.default)({}, formState.values);
            if (hasSyncErrors()) {
                markAllFieldsTouched();
                resetModifiedAfterSubmit();
                state.formState.submitFailed = true;
                notifyFormListeners();
                notifyFieldListeners();
                return; // no submit for you!!
            }
            var asyncValidationPromisesKeys = Object.keys(asyncValidationPromises);
            if (asyncValidationPromisesKeys.length) {
                // still waiting on async validation to complete...
                Promise.all(asyncValidationPromisesKeys.map(function(key) {
                    return asyncValidationPromises[Number(key)];
                })).then(api.submit, console.error);
                return;
            }
            var submitIsBlocked = beforeSubmit();
            if (submitIsBlocked) return;
            var resolvePromise;
            var completeCalled = false;
            var complete = function complete(errors) {
                formState.submitting = false;
                var resetWhileSubmitting = formState.resetWhileSubmitting;
                if (resetWhileSubmitting) formState.resetWhileSubmitting = false;
                if (errors && $f9a9822f8af64e2a$var$hasAnyError(errors)) {
                    formState.submitFailed = true;
                    formState.submitSucceeded = false;
                    formState.submitErrors = errors;
                    formState.submitError = errors[$f9a9822f8af64e2a$export$97cd7fc25dd32915];
                    markAllFieldsTouched();
                } else {
                    if (!resetWhileSubmitting) {
                        formState.submitFailed = false;
                        formState.submitSucceeded = true;
                    }
                    afterSubmit();
                }
                notifyFormListeners();
                notifyFieldListeners();
                completeCalled = true;
                if (resolvePromise) resolvePromise(errors);
                return errors;
            };
            formState.submitting = true;
            formState.submitFailed = false;
            formState.submitSucceeded = false;
            formState.lastSubmittedValues = (0, $bS32t.default)({}, formState.values);
            resetModifiedAfterSubmit();
            // onSubmit is either sync, callback or async with a Promise
            var result = onSubmit(formState.values, api, complete);
            if (!completeCalled) {
                if (result && $f9a9822f8af64e2a$var$isPromise(result)) {
                    // onSubmit is async with a Promise
                    notifyFormListeners(); // let everyone know we are submitting
                    notifyFieldListeners(); // notify fields also
                    return result.then(complete, function(error) {
                        complete();
                        throw error;
                    });
                } else if (onSubmit.length >= 3) {
                    // must be async, so we should return a Promise
                    notifyFormListeners(); // let everyone know we are submitting
                    notifyFieldListeners(); // notify fields also
                    return new Promise(function(resolve) {
                        resolvePromise = resolve;
                    });
                } else // onSubmit is sync
                complete(result);
            }
        },
        subscribe: function subscribe(subscriber, subscription) {
            if (!subscriber) throw new Error("No callback given.");
            if (!subscription) throw new Error("No subscription provided. What values do you want to listen to?");
            var memoized = $f9a9822f8af64e2a$var$memoize(subscriber);
            var subscribers = state.subscribers;
            var index = subscribers.index++;
            subscribers.entries[index] = {
                subscriber: memoized,
                subscription: subscription,
                notified: false
            };
            var nextFormState = calculateNextFormState();
            $f9a9822f8af64e2a$var$notifySubscriber(memoized, subscription, nextFormState, nextFormState, $f9a9822f8af64e2a$var$filterFormState, true);
            return function() {
                delete subscribers.entries[index];
            };
        }
    };
    return api;
}

});

parcelRegister("8tHJX", function(module, exports) {

$parcel$export(module.exports, "default", () => $62c2f612c5adb35a$export$2e2bcd8739ae039);

var $lqWDn = parcelRequire("lqWDn");
//      
/**
 * Predicate to identify inputs that can have focus() called on them
 */ var $62c2f612c5adb35a$var$isFocusableInput = function isFocusableInput(wtf) {
    return !!(wtf && typeof wtf.focus === 'function');
};
//      
/**
 * Gets all the inputs inside all forms on the page
 */ var $62c2f612c5adb35a$var$getAllInputs = function getAllInputs() {
    if (typeof document === 'undefined') return [];
    return Array.prototype.slice.call(document.forms).reduce(function(accumulator, form) {
        return accumulator.concat(Array.prototype.slice.call(form).filter($62c2f612c5adb35a$var$isFocusableInput));
    }, []);
};
//      
/**
 * Finds the input by looking if the name attribute path is existing in the errors object
 */ var $62c2f612c5adb35a$var$findInput = function findInput(inputs, errors) {
    return inputs.find(function(input) {
        return input.name && (0, $lqWDn.getIn)(errors, input.name);
    });
};
//      
var $62c2f612c5adb35a$var$noop = function noop() {};
var $62c2f612c5adb35a$var$createDecorator = function createDecorator(getInputs, findInput$$1) {
    return function(form) {
        var focusOnFirstError = function focusOnFirstError(errors) {
            if (!getInputs) getInputs = $62c2f612c5adb35a$var$getAllInputs;
            if (!findInput$$1) findInput$$1 = $62c2f612c5adb35a$var$findInput;
            var firstInput = findInput$$1(getInputs(), errors);
            if (firstInput) firstInput.focus();
        }; // Save original submit function
        var originalSubmit = form.submit; // Subscribe to errors, and keep a local copy of them
        var state = {};
        var unsubscribe = form.subscribe(function(nextState) {
            state = nextState;
        }, {
            errors: true,
            submitErrors: true
        }); // What to do after submit
        var afterSubmit = function afterSubmit() {
            var _state = state, errors = _state.errors, submitErrors = _state.submitErrors;
            if (errors && Object.keys(errors).length) focusOnFirstError(errors);
            else if (submitErrors && Object.keys(submitErrors).length) focusOnFirstError(submitErrors);
        }; // Rewrite submit function
        form.submit = function() {
            var result = originalSubmit.call(form);
            if (result && typeof result.then === 'function') // async
            result.then(afterSubmit, $62c2f612c5adb35a$var$noop);
            else // sync
            afterSubmit();
            return result;
        };
        return function() {
            unsubscribe();
            form.submit = originalSubmit;
        };
    };
};
//      
/**
 * Generates a function to get all the inputs in a form with the specified name
 */ var $62c2f612c5adb35a$export$a53c79cbd9f0d029 = function getFormInputs(name) {
    return function() {
        if (typeof document === 'undefined') return [];
         // $FlowFixMe
        var form = document.forms[name];
        return form && form.length ? Array.prototype.slice.call(form).filter($62c2f612c5adb35a$var$isFocusableInput) : []; // cast cheat to get from HTMLFormElement children to FocusableInput
    };
};
var //
$62c2f612c5adb35a$export$2e2bcd8739ae039 = $62c2f612c5adb35a$var$createDecorator;

});

parcelRegister("gZL7V", function(module, exports) {

var $ajB7H = parcelRequire("ajB7H");
/**
 * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
 * it's created. Arrays are created for missing index properties while objects
 * are created for all other missing properties. Use `_.setWith` to customize
 * `path` creation.
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to modify.
 * @param {Array|string} path The path of the property to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns `object`.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.set(object, 'a[0].b.c', 4);
 * console.log(object.a[0].b.c);
 * // => 4
 *
 * _.set(object, ['x', '0', 'y', 'z'], 5);
 * console.log(object.x[0].y.z);
 * // => 5
 */ function $c5f6e64373be0bfc$var$set(object, path, value) {
    return object == null ? object : $ajB7H(object, path, value);
}
module.exports = $c5f6e64373be0bfc$var$set;

});


parcelRegister("4utXj", function(module, exports) {

$parcel$export(module.exports, "Label", () => $b840ac9b23160efb$export$b04be29aa201d4f5);
$parcel$export(module.exports, "Legend", () => $b840ac9b23160efb$export$ed247974535929c7);
/* label.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
const $b840ac9b23160efb$var$fieldsetLabelStyles = null;
const $b840ac9b23160efb$export$b04be29aa201d4f5 = ({ children: children, htmlFor: htmlFor, id: id, testId: testId })=>/*#__PURE__*/ (0, $2OMIu.jsx)("label", {
        id: id,
        htmlFor: htmlFor,
        "data-testid": testId,
        className: (0, $bwpsq.default)([
            "_11c8dcr7 _1e0c1o8l _syaz1gjq _k48pmoej _6rth1b66 _1pfhze3t"
        ]),
        children: children
    });
const $b840ac9b23160efb$export$ed247974535929c7 = ({ children: children })=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)("legend", {
        className: (0, $bwpsq.default)([
            "_11c8dcr7 _1e0c1o8l _syaz1gjq _k48pmoej _6rth1b66 _1pfhze3t"
        ]),
        children: children
    });
};

});

parcelRegister("8TOd3", function(module, exports) {

$parcel$export(module.exports, "default", () => $acdf2127d61f3c98$export$2e2bcd8739ae039);
/* required-asterisk.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
const $acdf2127d61f3c98$var$requiredIndicatorStyles = null;
function $acdf2127d61f3c98$export$2e2bcd8739ae039() {
    return /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
        "aria-hidden": "true",
        title: "required",
        className: (0, $bwpsq.default)([
            "_syaz1ick _ect41gqc _bozgv77o"
        ]),
        children: "*"
    });
}

});



parcelRegister("1rKpn", function(module, exports) {

$parcel$export(module.exports, "default", () => $96338d4f59702d5c$export$2e2bcd8739ae039);
/* form-footer.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
const $96338d4f59702d5c$var$formFooterWrapperStyles = null;
const $96338d4f59702d5c$var$justifyContentStyles = null;
function $96338d4f59702d5c$export$2e2bcd8739ae039({ align: align = 'end', children: children }) {
    return /*#__PURE__*/ (0, $2OMIu.jsx)("footer", {
        className: (0, $bwpsq.default)([
            "_1e0c1txw _1bahesu3 _1pfh1ejb",
            align === 'start' && "_1bah1y6m"
        ]),
        children: children
    });
}

});

parcelRegister("9t5oA", function(module, exports) {

$parcel$export(module.exports, "default", () => $c1bc3ae9c9c38fcd$export$2e2bcd8739ae039);
/* text-area.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $bwpsq = parcelRequire("bwpsq");
var $lD23V = parcelRequire("lD23V");

var $5uXOq = parcelRequire("5uXOq");

var $9v1CN = parcelRequire("9v1CN");

var $iYZCl = parcelRequire("iYZCl");
const $c1bc3ae9c9c38fcd$var$packageName = "platform-pkg";
const $c1bc3ae9c9c38fcd$var$packageVersion = "0.0.0-use.local";
const $c1bc3ae9c9c38fcd$var$analyticsParams = {
    componentName: 'textArea',
    packageName: $c1bc3ae9c9c38fcd$var$packageName,
    packageVersion: $c1bc3ae9c9c38fcd$var$packageVersion
};
const $c1bc3ae9c9c38fcd$var$lineHeightBase = 20;
const $c1bc3ae9c9c38fcd$var$lineHeightCompact = 16;
const $c1bc3ae9c9c38fcd$var$compactVerticalPadding = 2;
const $c1bc3ae9c9c38fcd$var$verticalPadding = 6;
const $c1bc3ae9c9c38fcd$var$transitionDuration = '0.2s';
const $c1bc3ae9c9c38fcd$var$borderWidth = 2;
const $c1bc3ae9c9c38fcd$var$baseStyles = null;
const $c1bc3ae9c9c38fcd$var$appearanceStyles = {
    standard: "_1dqonqa1 _kp821elr _1ltx1j9a _1bqs13gt _z1pvsyzs _19wt1elr _12ym1d5g _19qkv77o _1dbiv77o _1etu1v6z _zedr1v6z _1itd12x7 _1a4912x7 _17km1v6z _wg601v6z _858u1p6i _jomrr01l _7ehiq049 _186j1p6i _qu18syzs",
    subtle: "_1dqonqa1 _kp823acm _1ltx18uv _19wt1elr _12ym1d5g _19qkv77o _1dbiv77o _1etu1v6z _zedr1v6z _1itd12x7 _1a4912x7 _wg601v6z _17km1v6z _858u1p6i _jomrr01l _7ehiq049",
    none: "_1dqoglyw _kp823acm _1ltx18uv _19wt3acm _12ym18uv _19qkv77o _zedr12x7 _1dbiv77o _1etu12x7 _1itd12x7 _wg6012x7 _1a4912x7 _17km12x7 _858u3acm _jomr18uv _7ehinruj"
};
const $c1bc3ae9c9c38fcd$var$fontStyles = {
    default: "_ect41gqc",
    monospace: "_ect41odn _1tn22smr _14mdudxr",
    large: "_11c81ixg _1tn22smr"
};
const $c1bc3ae9c9c38fcd$var$resizeStyles = {
    horizontal: "_14zg1e08",
    vertical: "_14zg1e54",
    auto: "_14zg1hrf",
    smart: "_14zgglyw",
    none: "_14zgglyw"
};
const $c1bc3ae9c9c38fcd$var$setSmartHeight = (el)=>{
    // Always reset height to auto before calculating new height
    el.style.height = 'auto';
    const borderHeight = $c1bc3ae9c9c38fcd$var$borderWidth;
    const paddingBoxHeight = el.scrollHeight;
    const borderBoxHeight = paddingBoxHeight + borderHeight * 2;
    el.style.height = `${borderBoxHeight}px`;
};
const $c1bc3ae9c9c38fcd$var$InnerTextArea = /*#__PURE__*/ (0, $5uXOq.forwardRef)((props, ref)=>{
    const ourRef = (0, $5uXOq.useRef)(null);
    const { resize: resize = 'smart', appearance: appearance = 'standard', isCompact: isCompact = false, isRequired: isRequired = false, isReadOnly: isReadOnly = false, isDisabled: isDisabled = false, isInvalid: isInvalid = false, isMonospaced: isMonospaced = false, minimumRows: minimumRows = 2, testId: testId, maxHeight: maxHeight = '50vh', onBlur: onBlur, onFocus: onFocus, onChange: onChange, value: value, style: style, ...rest } = props;
    const borderHeight = (0, $5uXOq.useMemo)(()=>appearance === 'none' ? 2 : 1, [
        appearance
    ]);
    (0, $5uXOq.useEffect)(()=>{
        const el = ourRef.current;
        if (resize === 'smart' && el) $c1bc3ae9c9c38fcd$var$setSmartHeight(el);
    }, [
        resize,
        value
    ]);
    const onBlurWithAnalytics = (0, $9v1CN.usePlatformLeafEventHandler)({
        fn: (event)=>{
            onBlur && onBlur(event);
        },
        action: 'blurred',
        ...$c1bc3ae9c9c38fcd$var$analyticsParams
    });
    const onFocusWithAnalytics = (0, $9v1CN.usePlatformLeafEventHandler)({
        fn: (event)=>{
            onFocus && onFocus(event);
        },
        action: 'focused',
        ...$c1bc3ae9c9c38fcd$var$analyticsParams
    });
    const getTextAreaRef = (elementRef)=>{
        ourRef.current = elementRef;
        if (ref && typeof ref === 'object') // @ts-ignore
        ref.current = elementRef;
        if (ref && typeof ref === 'function') ref(elementRef);
    };
    const handleOnChange = (0, $5uXOq.useCallback)((e)=>{
        const el = ourRef.current;
        if (resize === 'smart' && el) $c1bc3ae9c9c38fcd$var$setSmartHeight(el);
        onChange && onChange(e);
    }, [
        onChange,
        resize
    ]);
    const controlProps = {
        'data-invalid': isInvalid ? isInvalid : undefined,
        'data-compact': isCompact ? isCompact : undefined,
        'data-testid': testId ? testId : undefined
    };
    const compactMinHeightStyles = null;
    return /*#__PURE__*/ (0, $2OMIu.jsx)("textarea", {
        ...controlProps,
        value: value,
        disabled: isDisabled,
        readOnly: isReadOnly,
        required: isRequired,
        ref: getTextAreaRef,
        onChange: handleOnChange,
        onBlur: onBlurWithAnalytics,
        onFocus: onFocusWithAnalytics,
        rows: minimumRows,
        ...rest,
        className: (0, $bwpsq.default)([
            "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _16jlkb7n _1o9zkb7n _i0dl1osq _2rko1sit _11c82smr _12ji1r31 _1qu2glyw _12y31o36 _1reo1wug _18m91wug _v564r5cv _189ee4h9 _1e0c1ule _vchhusvi _1bsb1osq _1ul9idpf _p12f1osq _kqswh2mm _syazj3m3 _slp31hna _153g78r2 _usy4mag2 _1a2sr6rt _vbqb9jg2 _j5dh13gf _cfjqkb7n _k3o7n7od _1goxglyw _13xeglyw _1fra78r2 _ibjd10ko _6zpvr6rt _19k01y1w _1idr1wmz _1lep9jg2 _nmhq1fiz _1n388sxn _1luh194a _ndzbr01l _1vj01cu8",
            $c1bc3ae9c9c38fcd$var$appearanceStyles[appearance],
            (0, $iYZCl.fg)('platform_design_system_team_safari_input_fix') && $c1bc3ae9c9c38fcd$var$fontStyles['large'],
            $c1bc3ae9c9c38fcd$var$fontStyles[isMonospaced ? 'monospace' : 'default'],
            $c1bc3ae9c9c38fcd$var$resizeStyles[resize],
            "_uzq71i7i _16lwuel1"
        ]),
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
            ...style,
            maxHeight: maxHeight,
            "--_6ny3x7": (0, $lD23V.default)($c1bc3ae9c9c38fcd$var$lineHeightCompact * minimumRows + $c1bc3ae9c9c38fcd$var$compactVerticalPadding * 2 + borderHeight * 2, "px"),
            "--_eorxnz": (0, $lD23V.default)($c1bc3ae9c9c38fcd$var$lineHeightBase * minimumRows + $c1bc3ae9c9c38fcd$var$verticalPadding * 2 + borderHeight * 2, "px")
        }
    });
}); /**
     * __Text area__
     *
     * A text area lets users enter long form text which spans over multiple lines.
     *
     * - [Examples](https://atlassian.design/components/textarea/examples)
     * - [Code](https://atlassian.design/components/textarea/code)
     * - [Usage](https://atlassian.design/components/textarea/usage)
     */ 
const $c1bc3ae9c9c38fcd$var$TextArea = /*#__PURE__*/ (0, $5uXOq.memo)(/*#__PURE__*/ (0, $5uXOq.forwardRef)(function TextArea(props, ref) {
    return /*#__PURE__*/ (0, $2OMIu.jsx)($c1bc3ae9c9c38fcd$var$InnerTextArea, {
        ref: ref,
        ...props
    });
}));
$c1bc3ae9c9c38fcd$var$TextArea.displayName = 'TextArea';
var $c1bc3ae9c9c38fcd$export$2e2bcd8739ae039 = $c1bc3ae9c9c38fcd$var$TextArea;

});

parcelRegister("5Ud9O", function(module, exports) {

$parcel$export(module.exports, "default", () => $6d94fb0adfded843$export$2e2bcd8739ae039);
/* FeedbackScoreButtons.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $47t9U = parcelRequire("47t9U");

var $du3Kd = parcelRequire("du3Kd");

var $adetW = parcelRequire("adetW");
const $6d94fb0adfded843$var$tooltipMessage = [
    'Strongly disagree',
    'Disagree',
    'Slightly disagree',
    'Neutral',
    'Slightly agree',
    'Agree',
    'Strongly agree'
];
const $6d94fb0adfded843$var$buttonWrapperStyles = null;
const $6d94fb0adfded843$var$descriptionWrapperStyles = null;
var $6d94fb0adfded843$export$2e2bcd8739ae039 = ({ onChange: onChange, value: value })=>/*#__PURE__*/ (0, $2OMIu.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
                className: (0, $bwpsq.default)([
                    "_1e0c1txw _1bah1yb4 _zdxokb7n _v5ynkb7n _13lsf1ug _1o0a1h6o _pof3u2gc"
                ]),
                children: Array.from({
                    length: 7
                }, (_, i)=>{
                    const score = i + 1;
                    const isSelected = value === score;
                    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $adetW.default), {
                        content: $6d94fb0adfded843$var$tooltipMessage[i],
                        hideTooltipOnClick: true,
                        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $47t9U.default), {
                            onClick: ()=>onChange(score),
                            isSelected: isSelected,
                            "aria-pressed": isSelected,
                            "aria-describedby": "contextualSurveyStatement",
                            "aria-label": $6d94fb0adfded843$var$tooltipMessage[i],
                            shouldFitContainer: true,
                            children: score
                        })
                    }, score);
                })
            }),
            /*#__PURE__*/ (0, $2OMIu.jsxs)("div", {
                "aria-hidden": true,
                className: (0, $bwpsq.default)([
                    "_1e0c1txw _19pku2gc _otyr1ejb _1bah1yb4 _nbgx1epz"
                ]),
                children: [
                    /*#__PURE__*/ (0, $2OMIu.jsx)((0, $du3Kd.default), {
                        color: "color.text.subtlest",
                        size: "UNSAFE_small",
                        weight: "semibold",
                        align: "start",
                        children: "Strongly disagree"
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsx)((0, $du3Kd.default), {
                        color: "color.text.subtlest",
                        size: "UNSAFE_small",
                        weight: "semibold",
                        align: "center",
                        children: "Neutral"
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsx)((0, $du3Kd.default), {
                        color: "color.text.subtlest",
                        size: "UNSAFE_small",
                        weight: "semibold",
                        align: "end",
                        children: "Strongly agree"
                    })
                ]
            })
        ]
    });

});


parcelRegister("9sj5Y", function(module, exports) {

$parcel$export(module.exports, "default", () => $0790493df30173e2$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");
const $0790493df30173e2$export$4e7f196112fea3c5 = 27;
function $0790493df30173e2$var$bind(target, eventName, handler, options) {
    target.addEventListener(eventName, handler, options);
    return function unbind() {
        target.removeEventListener(eventName, handler, options);
    };
}
function $0790493df30173e2$var$shouldDismiss(target) {
    if (!target) return true;
    if (!(target instanceof HTMLElement)) return true;
    // Closest doesn't exist for ie11
    // Because we cannot be sure if in a text area - just don't allow dismissing
    if (!target.closest) return false;
    const inTextArea = Boolean(target.closest('textarea'));
    // Allow dismissing if not in a textarea
    return !inTextArea;
}
function $0790493df30173e2$export$2e2bcd8739ae039({ onDismiss: onDismiss }) {
    const onDismissRef = (0, $5uXOq.useRef)(onDismiss);
    // Defensively accounting for consumer passing in a new function
    // each time. We just want to call the latest one
    (0, $5uXOq.useEffect)(()=>{
        onDismissRef.current = onDismiss;
    }, [
        onDismiss
    ]);
    (0, $5uXOq.useEffect)(()=>{
        let unbind;
        function onKeyDown(event) {
            if (event.keyCode !== $0790493df30173e2$export$4e7f196112fea3c5) return;
            // Escape pressed
            // We don't want to close if the user is typing in the text area
            if (!$0790493df30173e2$var$shouldDismiss(event.target)) return;
            if (unbind) // only want to call dismiss once
            unbind();
            onDismissRef.current();
        }
        unbind = $0790493df30173e2$var$bind(window, 'keydown', // @ts-ignore: the typescript for this is lame
        onKeyDown, {
            passive: true
        });
        // double calls to unbind is fine
        return unbind;
    }, []);
}

});





parcelRegister("carTE", function(module, exports) {

$parcel$export(module.exports, "default", () => $67ee9d9572627215$export$2e2bcd8739ae039);

var $GH25Y = parcelRequire("GH25Y");

var $jKwFV = parcelRequire("jKwFV");

var $1ACMO = parcelRequire("1ACMO");
const $67ee9d9572627215$export$8423d11067fbf579 = (0, $GH25Y.default)((0, $1ACMO.default));
var $67ee9d9572627215$export$2e2bcd8739ae039 = (0, $jKwFV.default)($67ee9d9572627215$export$8423d11067fbf579, 'flag');

});
parcelRegister("1ACMO", function(module, exports) {

$parcel$export(module.exports, "default", () => $03e8ad82bfcbebb2$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $8Rkzz = parcelRequire("8Rkzz");

var $1Ret3 = parcelRequire("1Ret3");
var $eYg78 = parcelRequire("eYg78");

var $bl3qT = parcelRequire("bl3qT");

var $eCifF = parcelRequire("eCifF");

var $cD3Ev = parcelRequire("cD3Ev");
class $03e8ad82bfcbebb2$export$2e2bcd8739ae039 extends (0, $5uXOq.Component) {
    static{
        this.defaultProps = {
            fireClickEvent: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
            primaryText: null,
            primaryAction: null,
            secondaryText: null,
            secondaryAction: null,
            icon: 'smallInfo'
        };
    }
    onClickActionHandler(action) {
        if (action && action.type === (0, $bl3qT.buttonActionTypes).LINK && action.data) window.open(action.data.url, action.data.target);
    }
    render() {
        const { title: title, body: body, primaryText: primaryText, secondaryText: secondaryText, icon: icon } = this.props;
        const actions = [
            {
                content: primaryText,
                onClick: this.onPrimaryClick
            }
        ];
        if (secondaryText) actions.push({
            content: secondaryText,
            onClick: this.onSecondaryClick
        });
        const selectedIcon = (0, $cD3Ev.default)[icon];
        const FlagIconComponent = selectedIcon && selectedIcon.component;
        const FlagIcon = FlagIconComponent ? /*#__PURE__*/ (0, $2OMIu.jsx)(FlagIconComponent, {
            label: selectedIcon.label,
            color: selectedIcon.color,
            spacing: "spacious"
        }) : null;
        return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $eYg78.default), {
            onDismissed: this.onDismiss,
            children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $1Ret3.default), {
                id: "engagement-flag",
                appearance: "normal",
                icon: FlagIcon,
                title: title,
                description: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $eCifF.default), {
                    html: body
                }),
                actions: actions
            })
        });
    }
    constructor(...args){
        super(...args), this.onDismiss = ()=>{
            this.props.fireClickEvent('dismiss');
        }, this.onPrimaryClick = ()=>{
            const { fireClickEvent: fireClickEvent, primaryAction: primaryAction } = this.props;
            fireClickEvent('primary');
            this.onClickActionHandler(primaryAction);
        }, this.onSecondaryClick = ()=>{
            const { fireClickEvent: fireClickEvent, secondaryAction: secondaryAction } = this.props;
            fireClickEvent('secondary');
            this.onClickActionHandler(secondaryAction);
        };
    }
}

});
parcelRegister("cD3Ev", function(module, exports) {

$parcel$export(module.exports, "default", () => $eb34ef5ecffa99ed$export$2e2bcd8739ae039);
/* eslint-disable @atlassian/tangerine/import/no-relative-package-imports, @atlassian/tangerine/import/no-restricted-paths, @atlassian/tangerine/import/entry-points, @atlassian/tangerine/import/no-parent-imports */ 
var $jjpGm = parcelRequire("jjpGm");

var $1YiP1 = parcelRequire("1YiP1");

var $c2qtv = parcelRequire("c2qtv");

var $ZaWb9 = parcelRequire("ZaWb9");

var $ic1wQ = parcelRequire("ic1wQ");

var $g4Ay1 = parcelRequire("g4Ay1");

var $14Mmg = parcelRequire("14Mmg");

var $8Tr9D = parcelRequire("8Tr9D");

const $eb34ef5ecffa99ed$var$flagMapping = {
    success: {
        component: (0, (/*@__PURE__*/$parcel$interopDefault($jjpGm))),
        label: 'success',
        color: `var(--ds-icon-success, ${(0, $4f06f72592355b39$exports).G300})`
    },
    error: {
        component: (0, (/*@__PURE__*/$parcel$interopDefault($ZaWb9))),
        label: 'error',
        color: `var(--ds-icon-danger, ${(0, $4f06f72592355b39$exports).R300})`
    },
    info: {
        component: (0, (/*@__PURE__*/$parcel$interopDefault($14Mmg))),
        label: 'info',
        color: `var(--ds-icon-information, ${(0, $4f06f72592355b39$exports).T300})`
    },
    warning: {
        component: (0, (/*@__PURE__*/$parcel$interopDefault($8Tr9D))),
        label: 'warning',
        color: `var(--ds-icon-warning, ${(0, $4f06f72592355b39$exports).Y300})`
    },
    smallInfo: {
        component: (0, (/*@__PURE__*/$parcel$interopDefault($g4Ay1))),
        label: 'info',
        color: `var(--ds-icon-discovery, ${(0, $4f06f72592355b39$exports).P300})`
    },
    comment: {
        component: (0, (/*@__PURE__*/$parcel$interopDefault($1YiP1))),
        label: 'comment',
        color: `var(--ds-icon, ${(0, $4f06f72592355b39$exports).N300})`
    },
    download: {
        component: (0, (/*@__PURE__*/$parcel$interopDefault($c2qtv))),
        label: 'download',
        color: `var(--ds-icon, ${(0, $4f06f72592355b39$exports).N300})`
    },
    feedback: {
        component: (0, (/*@__PURE__*/$parcel$interopDefault($ic1wQ))),
        label: 'comment',
        color: `var(--ds-icon, ${(0, $4f06f72592355b39$exports).N300})`
    }
};
var $eb34ef5ecffa99ed$export$2e2bcd8739ae039 = $eb34ef5ecffa99ed$var$flagMapping;

});
parcelRegister("1YiP1", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::dfb8e24ad0aeafedb3c07855964a196e>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $16f9feafc59e2960$var$_react = $16f9feafc59e2960$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $16f9feafc59e2960$var$_comment = $16f9feafc59e2960$var$_interopRequireDefault((parcelRequire("3u8H8")));

var $16f9feafc59e2960$var$_comment2 = $16f9feafc59e2960$var$_interopRequireDefault((parcelRequire("gedDA")));
function $16f9feafc59e2960$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for CommentIcon.
 * This component is CommentIcon, with `UNSAFE_fallbackIcon` set to "CommentIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for comments on objects.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $16f9feafc59e2960$var$CommentIcon = (props)=>/*#__PURE__*/ $16f9feafc59e2960$var$_react.default.createElement($16f9feafc59e2960$var$_comment.default, Object.assign({
        LEGACY_fallbackIcon: $16f9feafc59e2960$var$_comment2.default
    }, props));
$16f9feafc59e2960$var$CommentIcon.Name = 'CommentIconMigration';
var $16f9feafc59e2960$var$_default = module.exports.default = $16f9feafc59e2960$var$CommentIcon;

});
parcelRegister("3u8H8", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::451c857042316b193f6451d1ac5153c9>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $289aeb0e09e67d6b$var$_react = $289aeb0e09e67d6b$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $289aeb0e09e67d6b$var$_baseNew = $289aeb0e09e67d6b$var$_interopRequireDefault((parcelRequire("bFgPB")));
function $289aeb0e09e67d6b$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Comment".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for comments on objects.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $289aeb0e09e67d6b$var$CommentIcon = (props)=>/*#__PURE__*/ $289aeb0e09e67d6b$var$_react.default.createElement($289aeb0e09e67d6b$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M0 3.125A2.625 2.625 0 0 1 2.625.5h10.75A2.625 2.625 0 0 1 16 3.125v8.25A2.625 2.625 0 0 1 13.375 14H4.449l-3.327 1.901A.75.75 0 0 1 0 15.25zM2.625 2C2.004 2 1.5 2.504 1.5 3.125v10.833L4.05 12.5h9.325c.621 0 1.125-.504 1.125-1.125v-8.25C14.5 2.504 13.996 2 13.375 2zM12 6.5H4V5h8zm-3 3H4V8h5z" clip-rule="evenodd"/>`
    }, props));
$289aeb0e09e67d6b$var$CommentIcon.displayName = 'CommentIcon';
var $289aeb0e09e67d6b$var$_default = module.exports.default = $289aeb0e09e67d6b$var$CommentIcon;

});

parcelRegister("gedDA", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $bd08884026ec4182$var$_react = $bd08884026ec4182$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $aZfhv = parcelRequire("aZfhv");

var $bd08884026ec4182$var$_comment = $bd08884026ec4182$var$_interopRequireDefault((parcelRequire("3u8H8")));
function $bd08884026ec4182$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $bd08884026ec4182$var$CommentIcon = (props)=>/*#__PURE__*/ $bd08884026ec4182$var$_react.default.createElement($aZfhv.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><path d="M4.998 11.513c0-3.038 3.141-5.51 7.002-5.51s7.002 2.472 7.002 5.51c0 3.039-3.141 5.51-7.002 5.51s-7.002-2.471-7.002-5.51m14.84 7.771v-.001s-1.564-2.26-.767-3.116l-.037.02C20.261 14.902 21 13.279 21 11.513 21 7.371 16.963 4 12 4s-9 3.37-9 7.513 4.037 7.514 9 7.514c1.42 0 2.76-.285 3.957-.776 1.003 1.022 2.287 1.572 3.24 1.719l.002-.003a.5.5 0 0 0 .164.033.515.515 0 0 0 .474-.716"/><rect width="10" height="2" x="7" y="9" rx="1"/><rect width="5" height="2" x="7" y="12" rx="1"/></g></svg>`
    }, props, {
        newIcon: $bd08884026ec4182$var$_comment.default
    }));
$bd08884026ec4182$var$CommentIcon.displayName = 'CommentIcon';
var $bd08884026ec4182$var$_default = module.exports.default = $bd08884026ec4182$var$CommentIcon;

});


parcelRegister("c2qtv", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::647640fe09afef5813e2888b2ce1f074>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $8c3a354b48220eba$var$_react = $8c3a354b48220eba$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $8c3a354b48220eba$var$_download = $8c3a354b48220eba$var$_interopRequireDefault((parcelRequire("iCgyS")));

var $8c3a354b48220eba$var$_download2 = $8c3a354b48220eba$var$_interopRequireDefault((parcelRequire("WMY5M")));
function $8c3a354b48220eba$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for DownloadIcon.
 * This component is DownloadIcon, with `UNSAFE_fallbackIcon` set to "DownloadIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for file downloads.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $8c3a354b48220eba$var$DownloadIcon = (props)=>/*#__PURE__*/ $8c3a354b48220eba$var$_react.default.createElement($8c3a354b48220eba$var$_download.default, Object.assign({
        LEGACY_fallbackIcon: $8c3a354b48220eba$var$_download2.default
    }, props));
$8c3a354b48220eba$var$DownloadIcon.Name = 'DownloadIconMigration';
var $8c3a354b48220eba$var$_default = module.exports.default = $8c3a354b48220eba$var$DownloadIcon;

});
parcelRegister("iCgyS", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::a3903aba4213e0f68da56229d9d15d40>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $d8d89f5bebd7431e$var$_react = $d8d89f5bebd7431e$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $d8d89f5bebd7431e$var$_baseNew = $d8d89f5bebd7431e$var$_interopRequireDefault((parcelRequire("bFgPB")));
function $d8d89f5bebd7431e$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Download".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for file downloads.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $d8d89f5bebd7431e$var$DownloadIcon = (props)=>/*#__PURE__*/ $d8d89f5bebd7431e$var$_react.default.createElement($d8d89f5bebd7431e$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8.75 1v7.44l2.72-2.72 1.06 1.06-4 4a.75.75 0 0 1-1.06 0l-4-4 1.06-1.06 2.72 2.72V1zM1 13V9h1.5v4a.5.5 0 0 0 .5.5h10a.5.5 0 0 0 .5-.5V9H15v4a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2" clip-rule="evenodd"/>`
    }, props));
$d8d89f5bebd7431e$var$DownloadIcon.displayName = 'DownloadIcon';
var $d8d89f5bebd7431e$var$_default = module.exports.default = $d8d89f5bebd7431e$var$DownloadIcon;

});

parcelRegister("WMY5M", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $0b0b66f6e64509e9$var$_react = $0b0b66f6e64509e9$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $aZfhv = parcelRequire("aZfhv");

var $0b0b66f6e64509e9$var$_download = $0b0b66f6e64509e9$var$_interopRequireDefault((parcelRequire("iCgyS")));
function $0b0b66f6e64509e9$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $0b0b66f6e64509e9$var$DownloadIcon = (props)=>/*#__PURE__*/ $0b0b66f6e64509e9$var$_react.default.createElement($aZfhv.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><path fill-rule="nonzero" d="M10.687 17.292a.983.983 0 0 0-1.397 0 1 1 0 0 0 0 1.407l1.964 1.98a1.08 1.08 0 0 0 1.538 0l1.919-1.933a1 1 0 0 0 0-1.408.983.983 0 0 0-1.398 0l-1.29 1.3z"/><path fill-rule="nonzero" d="M13.001 19.993 13 10.006C13 9.451 12.552 9 12 9s-1 .45-1 1.007l.001 9.987c0 .555.448 1.006 1 1.006s1-.45 1-1.007"/><path d="M7.938 5.48a5 5 0 0 0-.777-.062C4.356 5.418 2 7.62 2 10.498 2 13.409 4.385 16 7.1 16h2.881v-1.993H7.1c-1.657 0-3.115-1.663-3.115-3.508 0-1.778 1.469-3.087 3.104-3.087h.012c.389 0 .686.05.97.15l.17.063c.605.248.875-.246.875-.246l.15-.267c.73-1.347 2.201-2.096 3.716-2.12a4.14 4.14 0 0 1 4.069 3.645l.046.34s.071.525.665.525c.013 0 .012.005.023.005h.254c1.136 0 1.976.959 1.976 2.158 0 1.207-.987 2.342-2.07 2.342h-3.964V16h3.964C20.105 16 22 13.955 22 11.665c0-2-1.312-3.663-3.138-4.074-.707-2.707-3.053-4.552-5.886-4.591-1.975.02-3.901.9-5.038 2.48"/></g></svg>`
    }, props, {
        newIcon: $0b0b66f6e64509e9$var$_download.default
    }));
$0b0b66f6e64509e9$var$DownloadIcon.displayName = 'DownloadIcon';
var $0b0b66f6e64509e9$var$_default = module.exports.default = $0b0b66f6e64509e9$var$DownloadIcon;

});


parcelRegister("ic1wQ", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::c129a0bf5d2aeea221ba2044e3fd85fd>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $d3ea8894cc996b15$var$_react = $d3ea8894cc996b15$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $d3ea8894cc996b15$var$_feedback = $d3ea8894cc996b15$var$_interopRequireDefault((parcelRequire("8AIGn")));

var $d3ea8894cc996b15$var$_feedback2 = $d3ea8894cc996b15$var$_interopRequireDefault((parcelRequire("7Oy6d")));
function $d3ea8894cc996b15$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for FeedbackIcon.
 * This component is FeedbackIcon, with `UNSAFE_fallbackIcon` set to "FeedbackIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Known uses: customer feedback.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $d3ea8894cc996b15$var$FeedbackIcon = (props)=>/*#__PURE__*/ $d3ea8894cc996b15$var$_react.default.createElement($d3ea8894cc996b15$var$_feedback.default, Object.assign({
        LEGACY_fallbackIcon: $d3ea8894cc996b15$var$_feedback2.default
    }, props));
$d3ea8894cc996b15$var$FeedbackIcon.Name = 'FeedbackIconMigration';
var $d3ea8894cc996b15$var$_default = module.exports.default = $d3ea8894cc996b15$var$FeedbackIcon;

});
parcelRegister("8AIGn", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::f238518c984ab5d0530bd2cff7eccbeb>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $6414588e271e0b61$var$_react = $6414588e271e0b61$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $6414588e271e0b61$var$_baseNew = $6414588e271e0b61$var$_interopRequireDefault((parcelRequire("bFgPB")));
function $6414588e271e0b61$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Feedback".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Known uses: customer feedback.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $6414588e271e0b61$var$FeedbackIcon = (props)=>/*#__PURE__*/ $6414588e271e0b61$var$_react.default.createElement($6414588e271e0b61$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M1 3a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H6.221l-4.064 2.63A.75.75 0 0 1 1 15V9.5h1.5v4.121l3.093-2A.75.75 0 0 1 6 11.5h7a.5.5 0 0 0 .5-.5V3a.5.5 0 0 0-.5-.5H3a.5.5 0 0 0-.5.5v2.75a.5.5 0 0 0 .5.5h5.44L7.22 5.03l1.06-1.06 2.5 2.5a.75.75 0 0 1 0 1.06l-2.5 2.5-1.06-1.06 1.22-1.22H3a2 2 0 0 1-2-2z" clip-rule="evenodd"/>`
    }, props));
$6414588e271e0b61$var$FeedbackIcon.displayName = 'FeedbackIcon';
var $6414588e271e0b61$var$_default = module.exports.default = $6414588e271e0b61$var$FeedbackIcon;

});

parcelRegister("7Oy6d", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $5b07a75022871eb5$var$_react = $5b07a75022871eb5$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $aZfhv = parcelRequire("aZfhv");

var $5b07a75022871eb5$var$_feedback = $5b07a75022871eb5$var$_interopRequireDefault((parcelRequire("8AIGn")));
function $5b07a75022871eb5$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $5b07a75022871eb5$var$FeedbackIcon = (props)=>/*#__PURE__*/ $5b07a75022871eb5$var$_react.default.createElement($aZfhv.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="m10.88 5.48-8.43 6.83c-.4.32-.58.96-.41 1.42l.1.27c.17.46.73.83 1.23.82l1.13-.02 6.06-.1 3.65-.06c.51-.01.79-.38.62-.86l-2.92-8.03c-.1-.29-.32-.44-.57-.44a.73.73 0 0 0-.46.18m-5.9 10.46 1.75 4.82a1 1 0 1 0 1.88-.68l-1.54-4.23zm13.71-9.11-2.82 1.03a1 1 0 1 0 .68 1.88l2.82-1.03a1 1 0 1 0-.68-1.88m-1.79 3.85a1 1 0 0 0-.64.77 1 1 0 0 0 .81 1.16l2.96.52a1 1 0 0 0 1.12-1.3l-.02-.05a1 1 0 0 0-.76-.62l-2.95-.52a.97.97 0 0 0-.51.05m-.56-7.65-1.93 2.3a1 1 0 0 0 1.53 1.29l1.93-2.3a1 1 0 0 0-.76-1.64 1 1 0 0 0-.77.36"/></svg>`
    }, props, {
        newIcon: $5b07a75022871eb5$var$_feedback.default
    }));
$5b07a75022871eb5$var$FeedbackIcon.displayName = 'FeedbackIcon';
var $5b07a75022871eb5$var$_default = module.exports.default = $5b07a75022871eb5$var$FeedbackIcon;

});


parcelRegister("g4Ay1", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::c283363b764d34f6b30155eda3eaef46>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $bb395ea99e3ede0c$var$_react = $bb395ea99e3ede0c$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $bb395ea99e3ede0c$var$_information = $bb395ea99e3ede0c$var$_interopRequireDefault((parcelRequire("dZiyP")));

var $bb395ea99e3ede0c$var$_info = $bb395ea99e3ede0c$var$_interopRequireDefault((parcelRequire("29O8Q")));
function $bb395ea99e3ede0c$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for InformationIcon.
 * This component is InformationIcon, with `UNSAFE_fallbackIcon` set to "EditorInfoIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Known uses: information state in section messages or inline messages.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $bb395ea99e3ede0c$var$InformationIcon = (props)=>/*#__PURE__*/ $bb395ea99e3ede0c$var$_react.default.createElement($bb395ea99e3ede0c$var$_information.default, Object.assign({
        LEGACY_fallbackIcon: $bb395ea99e3ede0c$var$_info.default
    }, props));
$bb395ea99e3ede0c$var$InformationIcon.Name = 'InformationIconMigration';
var $bb395ea99e3ede0c$var$_default = module.exports.default = $bb395ea99e3ede0c$var$InformationIcon;

});
parcelRegister("29O8Q", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $19235121229ec9ee$var$_react = $19235121229ec9ee$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $aZfhv = parcelRequire("aZfhv");

var $19235121229ec9ee$var$_information = $19235121229ec9ee$var$_interopRequireDefault((parcelRequire("dZiyP")));
function $19235121229ec9ee$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $19235121229ec9ee$var$EditorInfoIcon = (props)=>/*#__PURE__*/ $19235121229ec9ee$var$_react.default.createElement($aZfhv.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M12 20a8 8 0 1 1 0-16 8 8 0 0 1 0 16m0-8.5a1 1 0 0 0-1 1V15a1 1 0 0 0 2 0v-2.5a1 1 0 0 0-1-1m0-1.125a1.375 1.375 0 1 0 0-2.75 1.375 1.375 0 0 0 0 2.75"/></svg>`
    }, props, {
        newIcon: $19235121229ec9ee$var$_information.default
    }));
$19235121229ec9ee$var$EditorInfoIcon.displayName = 'EditorInfoIcon';
var $19235121229ec9ee$var$_default = module.exports.default = $19235121229ec9ee$var$EditorInfoIcon;

});





parcelRegister("gdk09", function(module, exports) {

$parcel$export(module.exports, "default", () => $6e6b4ecf6dadf6b7$export$2e2bcd8739ae039);

var $GH25Y = parcelRequire("GH25Y");

var $jKwFV = parcelRequire("jKwFV");

var $3FROo = parcelRequire("3FROo");
const $6e6b4ecf6dadf6b7$export$404a075b2b026e91 = (0, $GH25Y.default)((0, $3FROo.default));
var $6e6b4ecf6dadf6b7$export$2e2bcd8739ae039 = (0, $jKwFV.default)($6e6b4ecf6dadf6b7$export$404a075b2b026e91, 'modalDialog');

});
parcelRegister("3FROo", function(module, exports) {

$parcel$export(module.exports, "default", () => $4e9fc09dbc5c6807$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $c8uZH = parcelRequire("c8uZH");

var $bl3qT = parcelRequire("bl3qT");

var $eCifF = parcelRequire("eCifF");
function $4e9fc09dbc5c6807$var$header() {
    return null;
}
class $4e9fc09dbc5c6807$export$2e2bcd8739ae039 extends (0, $5uXOq.Component) {
    getActionButton(action, text, onClick) {
        return {
            text: text,
            onClick: (e)=>{
                if (action.type === (0, $bl3qT.buttonActionTypes).LINK && action.data) window.open(action.data.url, action.data.target);
                onClick(e);
            }
        };
    }
    getActions() {
        const { primaryAction: primaryAction, primaryText: primaryText, secondaryAction: secondaryAction, secondaryText: secondaryText } = this.props;
        const actions = [];
        if (primaryAction && primaryText) actions.push(this.getActionButton(primaryAction, primaryText, this.onPrimaryAction));
        if (secondaryAction && secondaryText) actions.push(this.getActionButton(secondaryAction, secondaryText, this.onSecondaryAction));
        return actions;
    }
    getAdditionalModalProps() {
        const props = {};
        const { imageSrc: imageSrc } = this.props;
        if (imageSrc) props.image = imageSrc;
        else props.header = $4e9fc09dbc5c6807$var$header;
        return props;
    }
    render() {
        const { title: title, body: body } = this.props;
        return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $c8uZH.default), {
            actions: this.getActions(),
            heading: title,
            ...this.getAdditionalModalProps(),
            children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $eCifF.default), {
                html: body
            })
        });
    }
    constructor(...args){
        super(...args), this.onPrimaryAction = ()=>{
            this.props.fireClickEvent('primary');
        }, this.onSecondaryAction = ()=>{
            this.props.fireClickEvent('secondary');
        };
    }
}

});
parcelRegister("c8uZH", function(module, exports) {

$parcel$export(module.exports, "default", () => $4375cdd8aeeb1df2$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $4VcMT = parcelRequire("4VcMT");
var $5nyvt = parcelRequire("5nyvt");

var $049UO = parcelRequire("049UO");
var $5jUuF = parcelRequire("5jUuF");
var $2Zvmh = parcelRequire("2Zvmh");

var $apF1d = parcelRequire("apF1d");

var $kKt3m = parcelRequire("kKt3m");
class $4375cdd8aeeb1df2$export$2e2bcd8739ae039 extends (0, $5uXOq.Component) {
    render() {
        const { actions: actions, children: children, heading: heading, experimental_shouldShowPrimaryButtonOnRight: // All of the following props except `...rest` are unused but were being
        // spread into the Modal, which it does not accept.
        experimental_shouldShowPrimaryButtonOnRight, footer: footer, header: header, image: image, ...rest } = this.props;
        const Header = this.headerComponent(this.props);
        const Footer = this.footerComponent(this.props);
        const CustomHeader = ()=>{
            const { titleId: titleId } = (0, $2Zvmh.useModal)();
            return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $apF1d.ModalHeading), {
                id: titleId,
                children: heading
            });
        };
        return(// TODO: This is a problem that needs solving: https://product-fabric.atlassian.net/browse/DSP-22238
        // eslint-disable-next-line @atlaskit/design-system/use-modal-dialog-close-button
        /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $049UO.default), {
            autoFocus: true,
            shouldCloseOnEscapePress: false,
            shouldCloseOnOverlayClick: false,
            shouldScrollInViewport: true,
            // @ts-ignore All of the following props were in the rest props, so I'm
            // making them explicit here even though the Modal doesn't accept them.
            experimental_shouldShowPrimaryButtonOnRight: experimental_shouldShowPrimaryButtonOnRight,
            footer: footer,
            header: header,
            heading: heading,
            image: image,
            ...rest,
            children: [
                /*#__PURE__*/ (0, $2OMIu.jsx)(Header, {}),
                /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5jUuF.default), {
                    children: /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $apF1d.ModalBody), {
                        children: [
                            heading && /*#__PURE__*/ (0, $2OMIu.jsx)(CustomHeader, {}),
                            children
                        ]
                    })
                }),
                /*#__PURE__*/ (0, $2OMIu.jsx)(Footer, {})
            ]
        }));
    }
    constructor(...args){
        super(...args), this.headerComponent = (props)=>{
            const { header: HeaderElement, image: src } = props;
            const ImageElement = ()=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $apF1d.ModalImage), {
                    src: src,
                    alt: ""
                });
            return HeaderElement || ImageElement;
        }, this.footerComponent = (props)=>{
            const { footer: FooterElement, actions: actionList, experimental_shouldShowPrimaryButtonOnRight: experimental_shouldShowPrimaryButtonOnRight = false } = props;
            const ActionsElement = ()=>actionList ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5nyvt.default).Provider, {
                    value: (0, $kKt3m.modalButtonTheme),
                    children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $apF1d.ModalActionContainer), {
                        shouldReverseButtonOrder: experimental_shouldShowPrimaryButtonOnRight,
                        children: actionList.map(({ text: text, key: key, ...rest }, idx)=>{
                            const variant = idx ? 'subtle-link' : 'primary';
                            return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $apF1d.ModalActionItem), {
                                children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $4VcMT.default), {
                                    appearance: variant,
                                    autoFocus: !idx,
                                    ...rest,
                                    children: text
                                })
                            }, key || (typeof text === 'string' ? text : `${idx}`));
                        })
                    })
                }) : null;
            return FooterElement || ActionsElement;
        };
    }
}

});
parcelRegister("apF1d", function(module, exports) {

$parcel$export(module.exports, "ModalBody", () => $2e8345cb3a5e6b52$export$cb540d8b0ef7906c);
$parcel$export(module.exports, "ModalHeading", () => $2e8345cb3a5e6b52$export$9af27c346834c182);
$parcel$export(module.exports, "ModalImage", () => $2e8345cb3a5e6b52$export$1355685fd5f8d257);
$parcel$export(module.exports, "ModalActionContainer", () => $2e8345cb3a5e6b52$export$633dda6b40ac1ac3);
$parcel$export(module.exports, "ModalActionItem", () => $2e8345cb3a5e6b52$export$c245e9f76e3299b1);
/* modal.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $70ITn = parcelRequire("70ITn");
const $2e8345cb3a5e6b52$var$modalBodyStyles = null;
// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-array-arguments -- Ignored via go/DSP-18766
const $2e8345cb3a5e6b52$var$modalHeadingStyles = null;
const $2e8345cb3a5e6b52$var$modalImageStyles = null;
const $2e8345cb3a5e6b52$var$modalActionContainerStyles = null;
const $2e8345cb3a5e6b52$var$modalActionContainerReversedStyles = null;
const $2e8345cb3a5e6b52$var$modalActionItemStyles = {
    root: "_6rth1b66 _1pfhze3t _12l21b66 _ahbq1b66"
};
const $2e8345cb3a5e6b52$export$cb540d8b0ef7906c = ({ children: children })=>/*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        className: (0, $bwpsq.default)([
            "_85i51jfw _1q511jfw _y4tipxbi _bozgpxbi _y3gn1h6o"
        ]),
        children: children
    });
const $2e8345cb3a5e6b52$export$9af27c346834c182 = ({ children: children, id: id })=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)("h1", {
        id: id,
        className: (0, $bwpsq.default)([
            "_11c8lodh _syaz1kw7 _6rthu2gc"
        ]),
        children: children
    });
};
const $2e8345cb3a5e6b52$export$1355685fd5f8d257 = ({ alt: alt, src: src })=>/*#__PURE__*/ (0, $2OMIu.jsx)("img", {
        alt: alt,
        src: src,
        className: (0, $bwpsq.default)([
            "_1bsb1osq _4t3i1wug _5fbc1sit _1s1g1sit _j722idpf"
        ])
    });
const $2e8345cb3a5e6b52$export$633dda6b40ac1ac3 = ({ children: children, shouldReverseButtonOrder: shouldReverseButtonOrder })=>/*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        className: (0, $bwpsq.default)([
            "_2lx2vrvc _1n261g80 _1e0c1txw _1bah1h6o _85i514no _1q51ze3t _y4ti1jfw _bozg1jfw",
            shouldReverseButtonOrder && "_2lx21sbv"
        ]),
        children: children
    });
const $2e8345cb3a5e6b52$export$c245e9f76e3299b1 = ({ children: children })=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $70ITn.default), {
        xcss: $2e8345cb3a5e6b52$var$modalActionItemStyles.root,
        children: children
    });

});







//# sourceMappingURL=async-engagement-messages.d57b1bc7.js.map
